// GENERATED by frontend/scripts/gen-tour-catalog.mjs from docs/tour/lessons.md.
// Do not edit by hand — edit the lesson list and run the script again.
import type { TourLesson, TourManagerPathKey, TourModule, TourPathKey } from './tourTypes';

export const TOUR_MODULES: TourModule[] = [
  {
    "id": "M01",
    "title": "First day: sign in and find your way (sales)",
    "lessonIds": [
      "M01-L01",
      "M01-L02",
      "M01-L03",
      "M01-L04",
      "M01-L05",
      "M01-L06",
      "M01-L07",
      "M01-L08"
    ]
  },
  {
    "id": "M02",
    "title": "Leads on the phone",
    "lessonIds": [
      "M02-L01",
      "M02-L02",
      "M02-L03",
      "M02-L04",
      "M02-L05",
      "M02-L06",
      "M02-L07",
      "M02-L08",
      "M02-L09"
    ]
  },
  {
    "id": "M03",
    "title": "Calls on the phone",
    "lessonIds": [
      "M03-L01",
      "M03-L02",
      "M03-L03",
      "M03-L04",
      "M03-L05",
      "M03-L06",
      "M03-L07",
      "M03-L08",
      "M03-L09",
      "M03-L10",
      "M03-L11"
    ]
  },
  {
    "id": "M04",
    "title": "After the call: wrap-up",
    "lessonIds": [
      "M04-L01",
      "M04-L02",
      "M04-L03",
      "M04-L04",
      "M04-L05"
    ]
  },
  {
    "id": "M05",
    "title": "Enquiries on the phone",
    "lessonIds": [
      "M05-L01",
      "M05-L02",
      "M05-L03"
    ]
  },
  {
    "id": "M06",
    "title": "Re-negotiate on the phone",
    "lessonIds": [
      "M06-L01",
      "M06-L02"
    ]
  },
  {
    "id": "M07",
    "title": "Help and updates on the phone",
    "lessonIds": [
      "M07-L01",
      "M07-L02"
    ]
  },
  {
    "id": "M08",
    "title": "Sales web: your day",
    "lessonIds": [
      "M08-L01",
      "M08-L02",
      "M08-L03",
      "M08-L04",
      "M08-L05",
      "M08-L06",
      "M08-L07",
      "M08-L08"
    ]
  },
  {
    "id": "M09",
    "title": "Sales web: enquiries and customers",
    "lessonIds": [
      "M09-L01",
      "M09-L02",
      "M09-L03",
      "M09-L04",
      "M09-L05",
      "M09-L06",
      "M09-L07",
      "M09-L08",
      "M09-L09",
      "M09-L10",
      "M09-L11"
    ]
  },
  {
    "id": "M10",
    "title": "Sales web: MD send-backs, orders, trucks",
    "lessonIds": [
      "M10-L01",
      "M10-L02",
      "M10-L03",
      "M10-L04",
      "M10-L05",
      "M10-L06"
    ]
  },
  {
    "id": "M11",
    "title": "My HR, profile and help (web, everyone)",
    "lessonIds": [
      "M11-L01",
      "M11-L02",
      "M11-L03",
      "M11-L04",
      "M11-L05",
      "M11-L06",
      "M11-L07"
    ]
  },
  {
    "id": "M12",
    "title": "Purchase: getting around",
    "lessonIds": [
      "M12-L01",
      "M12-L02",
      "M12-L03",
      "M12-L04"
    ]
  },
  {
    "id": "M13",
    "title": "Purchase: rates and masters",
    "lessonIds": [
      "M13-L01",
      "M13-L02",
      "M13-L03",
      "M13-L04",
      "M13-L05",
      "M13-L06",
      "M13-L07",
      "M13-L08",
      "M13-L09"
    ]
  },
  {
    "id": "M14",
    "title": "Purchase: customers",
    "lessonIds": [
      "M14-L01",
      "M14-L02",
      "M14-L03",
      "M14-L04"
    ]
  },
  {
    "id": "M15",
    "title": "Purchase: Deal Desk",
    "lessonIds": [
      "M15-L01",
      "M15-L02",
      "M15-L03",
      "M15-L04",
      "M15-L05",
      "M15-L06",
      "M15-L07",
      "M15-L08",
      "M15-L09",
      "M15-L10",
      "M15-L11",
      "M15-L12"
    ]
  },
  {
    "id": "M16",
    "title": "Purchase: renegotiation",
    "lessonIds": [
      "M16-L01",
      "M16-L02",
      "M16-L03",
      "M16-L04",
      "M16-L05"
    ]
  },
  {
    "id": "M17",
    "title": "Purchase: orders",
    "lessonIds": [
      "M17-L01",
      "M17-L02",
      "M17-L03",
      "M17-L04"
    ]
  },
  {
    "id": "M18",
    "title": "Purchase: allocation and dispatch",
    "lessonIds": [
      "M18-L01",
      "M18-L02",
      "M18-L03",
      "M18-L04",
      "M18-L05"
    ]
  },
  {
    "id": "M19",
    "title": "Purchase: tracking, rejections, held lots",
    "lessonIds": [
      "M19-L01",
      "M19-L02",
      "M19-L03",
      "M19-L04",
      "M19-L05",
      "M19-L06",
      "M19-L07",
      "M19-L08"
    ]
  },
  {
    "id": "M20",
    "title": "Logistics: cockpit",
    "lessonIds": [
      "M20-L01",
      "M20-L02",
      "M20-L03",
      "M20-L04"
    ]
  },
  {
    "id": "M21",
    "title": "Logistics: freight",
    "lessonIds": [
      "M21-L01",
      "M21-L02",
      "M21-L03"
    ]
  },
  {
    "id": "M22",
    "title": "Logistics: Trade Routes",
    "lessonIds": [
      "M22-L01",
      "M22-L02",
      "M22-L03",
      "M22-L04",
      "M22-L05",
      "M22-L06"
    ]
  },
  {
    "id": "M23",
    "title": "Logistics: Allocation Board",
    "lessonIds": [
      "M23-L01",
      "M23-L02",
      "M23-L03",
      "M23-L04",
      "M23-L05",
      "M23-L06"
    ]
  },
  {
    "id": "M24",
    "title": "Logistics: pipelines",
    "lessonIds": [
      "M24-L01",
      "M24-L02"
    ]
  },
  {
    "id": "M25",
    "title": "Logistics: Dispatch Tracker, stage by stage",
    "lessonIds": [
      "M25-L01",
      "M25-L02",
      "M25-L03",
      "M25-L04",
      "M25-L05",
      "M25-L06",
      "M25-L07",
      "M25-L08",
      "M25-L09",
      "M25-L10",
      "M25-L11",
      "M25-L12",
      "M25-L13",
      "M25-L14",
      "M25-L15",
      "M25-L16",
      "M25-L17",
      "M25-L18",
      "M25-L19"
    ]
  },
  {
    "id": "M26",
    "title": "Logistics: truck breakdown in transit",
    "lessonIds": [
      "M26-L01",
      "M26-L02",
      "M26-L03"
    ]
  },
  {
    "id": "M27",
    "title": "Logistics: rejections and lots",
    "lessonIds": [
      "M27-L01",
      "M27-L02"
    ]
  },
  {
    "id": "M28",
    "title": "Accountant: cockpit and truck form",
    "lessonIds": [
      "M28-L01",
      "M28-L02",
      "M28-L03",
      "M28-L04",
      "M28-L05",
      "M28-L06",
      "M28-L07",
      "M28-L08"
    ]
  },
  {
    "id": "M29",
    "title": "Accountant: books",
    "lessonIds": [
      "M29-L01",
      "M29-L02",
      "M29-L03",
      "M29-L04",
      "M29-L05",
      "M29-L06",
      "M29-L07",
      "M29-L08"
    ]
  },
  {
    "id": "M30",
    "title": "Accountant: invoices and documents",
    "lessonIds": [
      "M30-L01",
      "M30-L02",
      "M30-L03",
      "M30-L04",
      "M30-L05",
      "M30-L06"
    ]
  },
  {
    "id": "M31",
    "title": "Accountant: GST and compliance",
    "lessonIds": [
      "M31-L01",
      "M31-L02",
      "M31-L03",
      "M31-L06",
      "M31-L07",
      "M31-L08"
    ]
  },
  {
    "id": "M32",
    "title": "Accountant: reports, payroll and other money pages",
    "lessonIds": [
      "M32-L01",
      "M32-L02",
      "M32-L03",
      "M32-L04",
      "M32-L05",
      "M32-L06",
      "M32-L07",
      "M32-L08",
      "M32-L09"
    ]
  },
  {
    "id": "M33",
    "title": "Admin only: the MD's dashboard",
    "lessonIds": [
      "M33-L01",
      "M33-L02",
      "M33-L03",
      "M33-L04",
      "M33-L05",
      "M33-L06"
    ]
  },
  {
    "id": "M34",
    "title": "Admin only: Margin Desk",
    "lessonIds": [
      "M34-L01",
      "M34-L02",
      "M34-L03",
      "M34-L04",
      "M34-L05",
      "M34-L06",
      "M34-L07"
    ]
  },
  {
    "id": "M35",
    "title": "Admin only: leads, enquiries, customers",
    "lessonIds": [
      "M35-L01",
      "M35-L02",
      "M35-L03",
      "M35-L04"
    ]
  },
  {
    "id": "M36",
    "title": "Admin only: trucks, rejections, closing",
    "lessonIds": [
      "M36-L01",
      "M36-L02",
      "M36-L03",
      "M36-L04",
      "M36-L05",
      "M36-L06",
      "M36-L07",
      "M36-L08"
    ]
  },
  {
    "id": "M37",
    "title": "Admin only: users, access and settings",
    "lessonIds": [
      "M37-L01",
      "M37-L02",
      "M37-L03",
      "M37-L04",
      "M37-L05",
      "M37-L06",
      "M37-L07",
      "M37-L08",
      "M37-L09",
      "M37-L10",
      "M37-L11"
    ]
  }
];

export const TOUR_LESSONS: TourLesson[] = [
  {
    "id": "M01-L01",
    "moduleId": "M01",
    "number": 1,
    "title": "Sign in to the app",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "The sign-in screen says \"<company> Sales\" · \"Inside Sales · <company>\" (your company's name).",
      "Type your work email in \"Email\".",
      "Type your password in \"Password\". The eye shows or hides it.",
      "Tap \"Log in\".",
      "Red text tells you what went wrong: \"Enter your email and password.\" or \"Email or password incorrect.\".",
      "After sign-in the calling setup screen opens. Your admin has already done it — tap \"Continue → Home\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "runs before sign-in"
    }
  },
  {
    "id": "M01-L02",
    "moduleId": "M01",
    "number": 2,
    "title": "Set up calling and recording",
    "platform": "Android",
    "who": "Admin only — sets up a sales phone",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "Open the drawer → \"Calling setup & permissions\" (\"Mic, call recording, SIM\"). The page is \"Set up AURA calling & recording\".",
      "Tap \"Set AURA as your phone app\" → \"Set as default\". The chip turns \"AURA is default\".",
      "Allow \"Display over other apps\" and \"Caller ID & spam screening\".",
      "Allow \"Microphone + call audio\", \"Phone (call detection)\" and \"Call recording access (All files)\".",
      "Each card must show \"Granted\". \"Open Settings\" means you must change it in phone Settings.",
      "If a rep skipped this, the pre-call sheet shows \"AURA isn't your default phone app\" → \"Set as default\".",
      "The back arrow returns to Home."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M01-L03",
    "moduleId": "M01",
    "number": 3,
    "title": "Set up location, storage, camera and battery, then finish",
    "platform": "Android",
    "who": "Admin only — sets up a sales phone",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "Tap \"Location (background)\". Read \"Important: tap \"Change to allow all the time\"\" and do that on the second prompt.",
      "Allow \"Storage\" (\"Cache call recordings before upload on Wi-Fi\") and \"Camera (field lead photos)\".",
      "Samsung only: open \"Battery whitelist (Samsung)\" and \"Auto-restart\".",
      "Tap \"Continue → Home\".",
      "\"Skip for now · Limited features\" goes Home without setup — do not hand a phone over like that."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M01-L04",
    "moduleId": "M01",
    "number": 4,
    "title": "Find your way around the app",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Bottom bar: \"Home\", \"Leads\", the green phone button, \"Enquiry\", \"Re-negotiate\" (with a count).",
      "Tap the ☰ menu icon to open the drawer: your name and \"Inside Sales · Telecaller\".",
      "The drawer shows \"Report a bug\", \"Calling setup & permissions\" and the app version \"<company> Sales · v<version>\".",
      "\"Log out\" asks \"Log out?\" → \"Log out\" or \"Cancel\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Log out\""
    }
  },
  {
    "id": "M01-L05",
    "moduleId": "M01",
    "number": 5,
    "title": "Your Home screen and today's numbers",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Home greets you: \"Hello, <first name>\".",
      "\"TODAY'S CALLS\" shows how many \"customers due\" today.",
      "Tap \"Start calling\" to open today's queue.",
      "\"Re-negotiate\" (\"Price requests from Purchase\") shows how many asks wait for you.",
      "\"Add lead\" (\"Quick capture a new customer\") opens the new-lead form."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M01-L06",
    "moduleId": "M01",
    "number": 6,
    "title": "Forgot your password (app)",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On the sign-in screen tap \"Forgot password?\" under \"Password\".",
      "\"Reset password\" opens. Type your work email in \"Email\".",
      "Tap \"Send reset link\".",
      "The screen says \"If an account exists for <email>, we have sent a reset link.\" It says this for every email.",
      "Open the email on this phone or a computer and tap \"Reset password\". The link works for 1 hour.",
      "Set the new password on the web page, come back and log in. \"No email? Send again\" sends it once more."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "sends an email"
    }
  },
  {
    "id": "M01-L07",
    "moduleId": "M01",
    "number": 7,
    "title": "Forgot your password (web)",
    "platform": "Web",
    "who": "Everyone",
    "audience": "everyone",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On the web sign-in page click \"Forgot password?\".",
      "On \"Reset your password\" type your work email. Click \"Send reset link\".",
      "The page says \"If an account exists for <email>, we've sent a reset link.\" and \"The link expires in 1 hour.\" Click \"Back to sign in\".",
      "Open the email and click the link.",
      "Type \"New password\" and \"Confirm password\" (at least 8 characters). Click \"Reset password\".",
      "\"Your password has been reset. Redirecting to sign in…\". \"Invalid or expired reset link. Please request a new one.\" means ask again."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "sends an email"
    }
  },
  {
    "id": "M01-L08",
    "moduleId": "M01",
    "number": 8,
    "title": "Find your way around the web app",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "The sidebar is your menu: \"Trading Dashboard\", \"Call List\", \"Requirements\", \"Sales Orders\", \"Customers\", \"Renegotiations\" (with a count), \"My Pipelines\". You open only what is in your own menu.",
      "The bell shows your notifications.",
      "Click your initials for \"Profile\", \"Settings\", \"My HR\" (\"Leaves\", \"My Attendance\"), \"Report a bug\" and \"Logout\".",
      "Use \"Light mode\" / \"Dark mode\" and \"Switch to compact\" / \"Switch to comfortable\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M02-L01",
    "moduleId": "M02",
    "number": 1,
    "title": "Open Leads and read the segment chips",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Tap \"Leads\". The header says \"N companies\".",
      "Chips: \"All\", \"Prospect\", \"Customer\", \"Repeat\", \"Retarget\", \"Lost\", each with a count.",
      "Each card shows the company, its segment chip, \"Buyer\" / \"Seller\" and the commodities.",
      "The dial chip says \"Never called\", \"Due now\" or \"Cooling · Nd\".",
      "The line under it: \"N enquiries · N won · <last activity>\".",
      "\"No leads yet\" or \"Could not load leads\" if the list is empty or offline."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M02-L02",
    "moduleId": "M02",
    "number": 2,
    "title": "Look up a lead",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On Leads tap \"Search name, commodity or phone\" and type.",
      "\"Has number · N\" shows only leads with a phone.",
      "Tap a card to open the lead.",
      "\"No matches\" means nothing fits — clear the search."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M02-L03",
    "moduleId": "M02",
    "number": 3,
    "title": "Re-approach leads whose revisit date has come",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "The banner \"N leads due to re-approach\" — \"Retarget revisit dates have come up\" — appears on Leads.",
      "Tap it to see them.",
      "On a card tap \"Re-approach now\" (or \"Revisit\").",
      "A \"Lost\" card has only \"View\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M02-L04",
    "moduleId": "M02",
    "number": 4,
    "title": "Read a lead's detail",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "The summary shows the segment, \"N won\", company, Buyer/Seller, commodities and region.",
      "\"Contacts\" lists each person; \"DM\" marks the decision-maker. The number shows only if you are allowed to see numbers.",
      "\"Enquiry history\" lists past enquiries — \"Read-only · enquiries are managed in the pipeline\".",
      "The back arrow returns to Leads. \"Could not load lead\" → \"Go back\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M02-L05",
    "moduleId": "M02",
    "number": 5,
    "title": "Add another person to a lead",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On the lead tap \"Add contact\" next to \"Contacts\".",
      "The sheet says \"Another person at <company>\".",
      "Fill \"Name\", \"Phone\" (10 digits), and if you know them \"Role (optional)\" and \"Email (optional)\".",
      "Tap \"Save contact\". \"Contact added\" shows and the person is in the list.",
      "A number already on this customer is refused with the server's reason."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save contact\""
    }
  },
  {
    "id": "M02-L06",
    "moduleId": "M02",
    "number": 6,
    "title": "Move a lead to Retarget or mark it Lost",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On the lead find \"Move this lead\" — \"Currently <segment> — auto-derived from won enquiries. Override:\".",
      "Tap \"Move to Retarget\" and pick \"30 d\", \"60 d\" or \"90 d\". It comes back when the revisit is due.",
      "Or tap \"Mark as Lost\".",
      "\"Moved to Retarget\" / \"Marked as Lost\" confirms. \"Could not move lead\" means try again."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "the move"
    }
  },
  {
    "id": "M02-L07",
    "moduleId": "M02",
    "number": 7,
    "title": "Add a new lead",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On Home tap \"Add lead\". \"Normal Lead\" opens.",
      "Fill \"FULL NAME *\", \"MOBILE *\" and \"COMPANY NAME *\".",
      "\"GSTIN (OPTIONAL)\" + \"Verify\" if you have it.",
      "\"PRODUCT / COMMODITY *\" → \"Select a commodity\". \"REGION *\" → \"Select city\" (search, or \"Use '<typed>'\").",
      "Tap \"Save lead\". Red text tells you what is missing."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save lead\""
    }
  },
  {
    "id": "M02-L08",
    "moduleId": "M02",
    "number": 8,
    "title": "Add more details: contacts, decision-maker, notes",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On the new-lead form open \"More details (optional)\".",
      "Under \"PRIMARY CONTACT\" fill \"ROLE / DESIGNATION\" and \"DECISION MAKER?\" Yes / No.",
      "\"ADDITIONAL CONTACTS\" → \"+ Add contact\" for a second person.",
      "Type in \"NOTES\".",
      "\"Save & add another\" saves and clears the form for the next lead."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M02-L09",
    "moduleId": "M02",
    "number": 9,
    "title": "Schedule a follow-up without calling",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On the pre-call sheet tap \"Schedule a follow-up\".",
      "Pick the date and time of the next call. Save.",
      "Or open the lead and use \"Schedule a follow-up\" there.",
      "The lead comes back in your queue on that date."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    },
    "note": "Pending fix 2026-10-09 — labels to re-check."
  },
  {
    "id": "M03-L01",
    "moduleId": "M03",
    "number": 1,
    "title": "Call a lead",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On a lead card tap the green phone (or the phone on a contact row). The pre-call sheet opens.",
      "Read the stage pill, \"LEAD SNAPSHOT\", \"LAST CALL\", \"NEXT FOLLOW-UP\", \"QUOTATIONS\" and \"CALL NOTES & ACTIVITY\".",
      "\"View all in Lead Detail\" opens the lead.",
      "Tap \"Call Now\". \"Call failed: …\" or \"Dialer timed out — please try again\" tells you what went wrong.",
      "\"WhatsApp\" and \"Email\" are on the same sheet."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "places a call"
    }
  },
  {
    "id": "M03-L02",
    "moduleId": "M03",
    "number": 2,
    "title": "Today's queue in the Call Hub",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Tap the green phone button. The Call Hub opens on \"Sprint\".",
      "\"Today's queue\" shows \"QUEUE\" N \"leads\" and \"N to go\".",
      "The stats: \"Queued\", \"High\", \"Medium\", \"Low\".",
      "\"Up next\" lists the next leads; \"View queue\" shows all.",
      "\"No calls queued\" → \"Open Keypad\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M03-L03",
    "moduleId": "M03",
    "number": 3,
    "title": "Run a sprint",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Tap \"Start Sprint\" (\"Auto-dials your queue in order\").",
      "\"SPRINT · HIGH PRIORITY\" shows \"N of N leads\". \"UP NEXT · CALLING IN Ns\" counts down.",
      "\"Pause\" / \"Resume\", \"Skip\", \"Stop\".",
      "After each call and wrap-up you come back here and the next lead is ready.",
      "\"LOCKED · …\" chips explain why a lead cannot be called now (cooldown, max retries, scheduled, DND).",
      "\"Sprint complete!\" → \"Done\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "dials"
    }
  },
  {
    "id": "M03-L04",
    "moduleId": "M03",
    "number": 4,
    "title": "Dial a number from the keypad",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "In the Call Hub tap \"Keypad\". Type in \"Enter number\" (long-press 0 for +). \"Delete\" removes a digit.",
      "Tap the green call button.",
      "\"Add lead\" opens the new-lead form for that number.",
      "\"Recents\" → \"View all\". On a row ⋮ → \"Add as Lead\" or \"Save to Contacts\".",
      "\"Hide keypad\" / \"Show keypad\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "dials"
    }
  },
  {
    "id": "M03-L05",
    "moduleId": "M03",
    "number": 5,
    "title": "Call from your phone contacts",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Tap \"Contacts\". First time: \"Dial from your phonebook\" → \"Allow contacts\".",
      "\"Read-only — we never change your contacts\".",
      "\"Search name or number\". Tap a row to call.",
      "A \"LEAD\" badge means it is already a lead → \"Open lead\"; otherwise \"Add as lead\".",
      "\"Add\" saves a new number to the phone (\"Phone *\", \"Name (optional)\", \"Designation (optional)\").",
      "\"Select\" → tick people → \"Call N contacts\" starts a calling queue. \"Cancel\" ends select mode."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "dials"
    }
  },
  {
    "id": "M03-L06",
    "moduleId": "M03",
    "number": 6,
    "title": "Work a hand-picked calling queue",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "After \"Call N contacts\" the \"CALLING QUEUE\" opens (\"Ad-hoc · hand-picked contacts\").",
      "\"Call now\", then \"Redial\" or \"Next contact\".",
      "\"Open lead\" / \"Add as lead\" for the person on screen.",
      "\"UP NEXT\" and \"Then (N)\" show who is next. \"Stop\" ends it.",
      "\"Queue complete\" → \"Back to Contacts\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "dials"
    }
  },
  {
    "id": "M03-L07",
    "moduleId": "M03",
    "number": 7,
    "title": "Read your call log",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Open \"Recents\" (\"Your call log\").",
      "Filters \"All\", \"Missed\", \"Unknown\".",
      "Calls are grouped \"Today\", \"Yesterday\", \"Earlier\".",
      "⋮ on a row → \"Add as Lead\" or \"Save to Contacts\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M03-L08",
    "moduleId": "M03",
    "number": 8,
    "title": "During a call",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"CALLING · VIA AURA\" — \"Ringing…\". \"Mute\", \"Speaker\", \"Cancel call\".",
      "In the call the \"Recording\" pulse shows the call is recorded.",
      "\"Keypad\" opens \"IVR / Extension Notepad\" to note digits.",
      "Press the red button to end. \"Force end call & save recording\" if it hangs.",
      "\"Recording queued for upload — will send on Wi-Fi\" is normal.",
      "If the system dialer took the call: \"Hung up? Tap to wrap up\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "live call"
    }
  },
  {
    "id": "M03-L09",
    "moduleId": "M03",
    "number": 9,
    "title": "Answer an incoming call",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"INCOMING CALL\" shows the caller, or \"Unknown number\" / \"Not in your leads\".",
      "\"Accept\" or \"Decline\". \"Message\" sends a quick text.",
      "\"Could not answer call — falling through to system dialer.\" means use the phone's own screen."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "live call"
    }
  },
  {
    "id": "M03-L10",
    "moduleId": "M03",
    "number": 10,
    "title": "Fix call recording with diagnostics",
    "platform": "Android",
    "who": "Admin only — fixes a sales phone",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "The in-call banner \"Recording off …\" opens \"Recording diagnostics\".",
      "Read \"Device info\", \"Last failure\", \"Last 10 calls — lifecycle trace\", \"Upload queue\". \"Refresh\".",
      "\"Test recording (3s)\" records a short sample.",
      "\"Run layer probes (L1–L5)\".",
      "\"Share trace\" sends the trace to support."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Share trace\""
    }
  },
  {
    "id": "M03-L11",
    "moduleId": "M03",
    "number": 11,
    "title": "Force a locked call in a sprint",
    "platform": "Android",
    "who": "Manager only",
    "audience": "salesManager",
    "managerOnly": true,
    "adminOnly": false,
    "steps": [
      "In a sprint a lead shows \"LOCKED · <reason>\".",
      "Only the Sales Manager sees \"Force call\".",
      "Tap it only when the customer asked for a call now."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "dials"
    }
  },
  {
    "id": "M04-L01",
    "moduleId": "M04",
    "number": 1,
    "title": "Wrap up a connected call",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "After the call \"How did it go?\" opens with \"<name> · mm:ss call\".",
      "Keep \"Connected\".",
      "\"Spoke to the decision-maker?\" — tap \"Yes\" or \"No\". It is saved; \"Answer not saved — tap again\" means tap again.",
      "Pick \"Create enquiry\" or \"Follow-up\".",
      "Type what the customer said in \"Quick notes\".",
      "Save. Android Back also leaves wrap-up."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a finished call"
    }
  },
  {
    "id": "M04-L02",
    "moduleId": "M04",
    "number": 2,
    "title": "Wrap up a call that did not connect",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Tap \"Not connected\".",
      "Pick \"No answer\", \"Busy\", \"Call back\" or \"DND\".",
      "Save. The lead goes back in your queue by the cooldown."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a finished call"
    }
  },
  {
    "id": "M04-L03",
    "moduleId": "M04",
    "number": 3,
    "title": "The customer is not interested, or lost",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On \"Connected\" tap \"Not interested — Potential\".",
      "\"Revisit this customer in…\" → \"30 days\", \"60 days\" or \"90 days\" (\"Skip\" = 30).",
      "Or tap \"Lost / not a fit\".",
      "Save. The lead moves to Retarget or Lost.",
      "\"Outcome not saved — … Try again.\" means nothing was saved — try again."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a finished call"
    }
  },
  {
    "id": "M04-L04",
    "moduleId": "M04",
    "number": 4,
    "title": "Set a follow-up reminder in wrap-up",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On wrap-up open \"Schedule follow-up\" (\"Optional reminder\").",
      "Pick the date, then the time.",
      "Save. The lead is due on that day."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a finished call"
    }
  },
  {
    "id": "M04-L05",
    "moduleId": "M04",
    "number": 5,
    "title": "Save an unknown number after a call",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Call ended\" — \"Save this number?\".",
      "\"Add as Lead\" opens the new-lead form.",
      "\"Save to Contacts\" saves it on the phone.",
      "\"Not now\" closes."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a finished call"
    }
  },
  {
    "id": "M05-L01",
    "moduleId": "M05",
    "number": 1,
    "title": "Raise an enquiry after a call",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "In wrap-up tap \"Create enquiry\". \"Create enquiry\" opens with the customer \"Attached\".",
      "\"Product / commodity\" (type or tap a chip). \"Grade (optional)\" e.g. Sortex, FAQ.",
      "\"Quantity\" + \"KG\" / \"Qtl\" / \"MT\". \"Target rate\" — what the customer expects to pay.",
      "\"Ship to\": the delivery city name, not a PIN code. \"Bill to\": the billing party, defaults to the buyer.",
      "Tap \"Send to Purchase\". \"Enquiry raised\" shows the summary.",
      "\"Next customer\" or \"Back to home\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send to Purchase\""
    }
  },
  {
    "id": "M05-L02",
    "moduleId": "M05",
    "number": 2,
    "title": "Raise an enquiry without a call",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Tap \"Enquiry\" → \"New enquiry\".",
      "\"New enquiry — pick a lead\": search and tap the lead.",
      "Or from a lead's page tap \"Raise enquiry\".",
      "Fill the form as in M05-L01."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send to Purchase\""
    }
  },
  {
    "id": "M05-L03",
    "moduleId": "M05",
    "number": 3,
    "title": "Track your enquiries",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Tap \"Enquiry\". The header says \"N enquiries\".",
      "Chips: \"All\", \"With Purchase\", \"Partly approved\", \"Approved\", \"Closed\", \"Lost\".",
      "\"Search commodity or city\". Pull down to refresh.",
      "Tap a card. \"Enquiry\" shows \"Customer\", \"Grade\", \"Quantity\", \"Target rate\", \"Ship to\", \"Bill to\", \"Raised on\" — \"Read-only · Purchase manages this enquiry\"."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M06-L01",
    "moduleId": "M06",
    "number": 1,
    "title": "Read the re-negotiate inbox",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "The \"Re-negotiate\" tab badge (and the Home tile) shows how many asks wait.",
      "\"N requests from Purchase\". Each card: customer, \"Urgent\", product · qty, \"ORIGINAL\" struck through and the \"TARGET\" ₹/unit.",
      "\"No open re-negotiate requests\" when you are clear."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M06-L02",
    "moduleId": "M06",
    "number": 2,
    "title": "Answer a re-negotiate request",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Tap a card. \"YOUR TARGET — HIT OR BEAT\" shows the price and Purchase's reason.",
      "\"Call customer\".",
      "After the call pick \"Accept\" (\"Got the target or better\"), \"Counter\" (type the price) or \"Declined\" (\"Won't move\").",
      "Write a \"Note for Purchase\".",
      "Tap \"Send back to Purchase\". \"Request not found\" means the ask is closed → \"Open Re-negotiate inbox\"."
    ],
    "minutes": {
      "android": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send back to Purchase\""
    }
  },
  {
    "id": "M07-L01",
    "moduleId": "M07",
    "number": 1,
    "title": "Report a bug from the app",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Open the drawer → \"Report a bug\" (\"Tell the <company> team what went wrong\").",
      "\"What went wrong\" — e.g. \"Wrap-up did not save\".",
      "\"Details\" — what you tapped and what happened.",
      "\"How bad is it\": \"High\", \"Medium\" or \"Low\".",
      "Tap \"Send report\". \"Bug reported · TKT-xxxxx\" — note the number."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send report\""
    }
  },
  {
    "id": "M07-L02",
    "moduleId": "M07",
    "number": 2,
    "title": "Update the app when asked",
    "platform": "Android",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On Home, \"Update available\" — \"Version <x> is available.\" pops up.",
      "Tap \"Download\" and install. \"Later\" asks again next time you open the app.",
      "\"Update required\" has no \"Later\": install to keep working."
    ],
    "minutes": {
      "android": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "needs a newer build on the server"
    },
    "note": "Pending fix 2026-10-09 — record after the manifest entry is live on the demo backend."
  },
  {
    "id": "M08-L01",
    "moduleId": "M08",
    "number": 1,
    "title": "Read the Trading Dashboard",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "After sign-in you land on \"Trading Dashboard\" — \"what to do today\".",
      "\"Where every enquiry is — click a box to filter\".",
      "\"Truck dispatched\" and \"Delivered\" boxes list your trucks; \"My Pipelines →\" opens the truck list.",
      "\"Sales Orders\" opens your orders.",
      "Every list has a pager. \"Could not load the dashboard.\" → \"Retry\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L02",
    "moduleId": "M08",
    "number": 2,
    "title": "Read your own numbers",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Time range\": \"Today\", \"Last 7 days\", \"Last 30 days\", \"This month\", or \"Custom\" → \"From\" / \"To\" → \"Apply\".",
      "It \"Changes the boxes marked IN RANGE\".",
      "\"Answer MD\" — send-backs waiting for your sell price.",
      "\"Call today\" — follow-ups due + never-called leads.",
      "\"Waiting on Purchase\" and \"With Purchase\" — not yours to act on yet.",
      "\"Approved, no truck\" — SO made, no truck planned; chase logistics."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L03",
    "moduleId": "M08",
    "number": 3,
    "title": "Log a call from the dashboard",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Call today\" lists follow-ups that fell due and leads never called. Dial from the phone app.",
      "\"Open Enquiry\" opens the lead.",
      "After the call click \"Mark Called\" → \"Called <name>\".",
      "Pick \"Not now\", \"Interested\" or \"Call back on\" (date) → \"Call back\".",
      "\"Could not log the call.\" means try again."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "the outcome"
    }
  },
  {
    "id": "M08-L04",
    "moduleId": "M08",
    "number": 4,
    "title": "Read the Call List",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Open Call List\" (or \"Call List\" in the menu): \"<n> leads with a phone · dial in the AURA Sales app\".",
      "Tiles \"Follow-up due today\", \"Never called\", \"All leads\".",
      "Search \"Search name, company, city, phone…\" and \"All cities\".",
      "Groups \"Call first · follow-up due\", \"New · never called\", \"Called before\"; chips \"Overdue N days\", \"Follow up today HH:MM\", \"New\".",
      "\"← Trading Dashboard\" goes back."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L05",
    "moduleId": "M08",
    "number": 5,
    "title": "Chase enquiries waiting on Purchase, or mark one lost",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Waiting on Purchase — not started\" lists enquiries sent 7+ days ago.",
      "\"Open →\" opens one.",
      "\"Lost\" → \"Mark <number> Lost\" → pick the reason from the list.",
      "Folds \"With Purchase, not you\" and \"Approved, waiting for a truck\" are read-only; chase, do not change."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Lost\""
    }
  },
  {
    "id": "M08-L06",
    "moduleId": "M08",
    "number": 6,
    "title": "Bring back a repeat buyer",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Customers to revisit\" — bought before, no open enquiry for 30+ days.",
      "\"+ New Enquiry\" on a repeat buyer starts an enquiry for them.",
      "\"Open Enquiries →\" opens Requirements filtered to that customer."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M08-L07",
    "moduleId": "M08",
    "number": 7,
    "title": "Rules: your list is yours",
    "platform": "Both",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "You see only the leads, enquiries, orders and trucks you raised or are assigned.",
      "You never see vendors, PO numbers, purchase cost or margin. Purchase and MD handle those.",
      "You cannot make or edit a Sales Order or PO; orders come when MD approves.",
      "You answer MD on \"Renegotiations\"; you never approve.",
      "Dial from the phone app; the web has no dialer.",
      "You may cancel your own order until MD approves it; after that only admin can.",
      "Delete / deactivate a customer is admin-only."
    ],
    "minutes": {
      "android": 1,
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "rules"
    }
  },
  {
    "id": "M08-L08",
    "moduleId": "M08",
    "number": 8,
    "title": "What the Sales Manager sees",
    "platform": "Web",
    "who": "Manager only",
    "audience": "salesManager",
    "managerOnly": true,
    "adminOnly": false,
    "steps": [
      "Your menu has no \"Requirements\" item; your enquiries open from the Trading Dashboard.",
      "You see the whole customer directory in \"Customers\".",
      "Enquiries, orders and trucks are still only the ones you raised or are assigned.",
      "Send-backs routed to you appear on \"Renegotiations\" like any rep's."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "rules"
    }
  },
  {
    "id": "M09-L01",
    "moduleId": "M09",
    "number": 1,
    "title": "Raise a new enquiry",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Click \"+ New enquiry\" on the dashboard (or \"+ New Enquiry\" on Requirements).",
      "\"Party *\" — search and pick the customer.",
      "\"Commodity *\", \"Grade (optional)\", \"Quantity (kg) *\" (shows MT), \"Target price (₹/kg) *\".",
      "Pick the delivery State and City.",
      "Click \"Create Enquiry\". Red text names anything missing."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Create Enquiry\""
    }
  },
  {
    "id": "M09-L02",
    "moduleId": "M09",
    "number": 2,
    "title": "Advanced options on an enquiry",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Open \"Advanced Options\". \"Bill To\" is \"Locked to GST\".",
      "\"Ship To (extra lines)\": address, village, sub-district.",
      "\"Payment term\" or \"Add custom payment term…\".",
      "\"Expected delivery\" date and \"Notes\" for Purchase."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M09-L03",
    "moduleId": "M09",
    "number": 3,
    "title": "Find your requirements",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Requirements\" — \"Veda Agro — Requirements\".",
      "The banner counts deals decided: approved, sent back, rejected.",
      "Filter pills, starting with \"Looking to Purchase\".",
      "\"Search enquiries...\". Columns show enquiry, party, raised by, status; \"Grade: <x>\" when set.",
      "Click a row to open your lead page."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M09-L04",
    "moduleId": "M09",
    "number": 4,
    "title": "Update an enquiry after a call",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "The lead page shows the customer, enquiry number and step.",
      "\"Customer & Call\": company, contact, phone.",
      "\"Call notes / log\": write what was discussed.",
      "\"Requirement\": product, quantity, target, delivery.",
      "Click \"Save\" → \"Saved successfully.\". \"← Back to Trading Dashboard\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save\""
    }
  },
  {
    "id": "M09-L05",
    "moduleId": "M09",
    "number": 5,
    "title": "Cancel your own order",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On Requirements find your enquiry and click the ban icon \"Cancel an order on <number>\".",
      "\"Cancel an order\": choose the one PO line to cancel.",
      "\"Cancel this purchase order?\" — type the reason and confirm.",
      "Once MD has approved the deal the icon is grey: \"MD-approved — only admin can cancel\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirming"
    }
  },
  {
    "id": "M09-L06",
    "moduleId": "M09",
    "number": 6,
    "title": "Find a customer and read the customer card",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Customers\" — \"Customer Master\".",
      "\"Search name, GSTIN, phone…\"; tabs \"active\" / \"Deactivated\" / \"all\".",
      "Click a row. \"Identity\", \"Contact & Terms\", \"History\".",
      "\"No extra delivery addresses\" means the primary shipping address is used."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M09-L07",
    "moduleId": "M09",
    "number": 7,
    "title": "Create a GST-verified customer",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"New Customer\" → \"New party\".",
      "\"GSTIN\" (15 characters) → \"Verify\". \"This GSTIN already exists as <name>.\" → \"Open existing\".",
      "The identity card locks: legal name, trade name, PAN, state.",
      "Fill \"Phone\", \"Email\", \"Payment terms\", \"Commodity\".",
      "\"Contacts\": \"Name *\", \"Mobile *\". Billing and shipping address.",
      "Click \"Create customer\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Create customer\""
    }
  },
  {
    "id": "M09-L08",
    "moduleId": "M09",
    "number": 8,
    "title": "Create an unregistered (B2C) customer",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "In \"New party\" tick \"Unregistered / B2C customer (no GSTIN)\".",
      "Type \"Customer name\" and \"Billing address\".",
      "Add a contact with a mobile.",
      "Click \"Create customer\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Create customer\""
    }
  },
  {
    "id": "M09-L09",
    "moduleId": "M09",
    "number": 9,
    "title": "Upload the customer's KYC documents",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "After create, \"KYC documents — <name>\" opens.",
      "Upload \"PAN card *\" and \"GST certificate *\" (PDF, JPG, PNG or WebP).",
      "Optional: \"Aadhaar card\", \"Photograph\", \"Other document\".",
      "\"Done\" unlocks when both required documents are in. Later uploads go on the customer card under \"KYC documents\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "upload"
    }
  },
  {
    "id": "M09-L10",
    "moduleId": "M09",
    "number": 10,
    "title": "Add the customer's bank details",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On the KYC step click \"+ Add bank details\".",
      "Scan a cancelled cheque, or type the account number and IFSC.",
      "Save. \"✓ Edit bank details\" shows it is on file."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M09-L11",
    "moduleId": "M09",
    "number": 11,
    "title": "Edit addresses and add delivery addresses",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On the customer card, \"Billing / shipping address\" → \"Edit\".",
      "\"Delivery addresses\" → \"+ Add\": label (e.g. Plant 2), city, full address.",
      "\"×\" removes one → \"Delivery address removed\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M10-L01",
    "moduleId": "M10",
    "number": 1,
    "title": "See what MD sent back",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "The \"Renegotiations\" item has a count.",
      "\"Renegotiations\" — \"Deals sent back by MD or Purchase — open each to respond\".",
      "Columns: enquiry and round, commodity, \"Sent back by\" (\"MD\" / \"Purchase\").",
      "On the dashboard \"Answer MD's send-back\" → \"Answer →\" opens the same page."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M10-L02",
    "moduleId": "M10",
    "number": 2,
    "title": "Tell MD you are on it",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Click \"Open →\". \"Renegotiation · MD sent this back\" — \"Respond & resend to MD\".",
      "The banner says what is needed, e.g. \"MD sent this back — Sell price needed\".",
      "\"On it — ETA:\" → \"~15 min\", \"today\" or \"tomorrow\".",
      "\"Nothing to answer here\" means it was already answered."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "the ETA"
    }
  },
  {
    "id": "M10-L03",
    "moduleId": "M10",
    "number": 3,
    "title": "Answer MD with a new sell price",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Type the \"Sell price (₹/kg)\".",
      "\"Your response to the MD\" — explain the change.",
      "Optional \"Note to the MD\".",
      "Click \"Confirm & resend to MD\" → \"✓ Sent to MD — nothing more needed.\".",
      "A ₹0 freight answer asks \"₹0 freight — pick a reason *\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Confirm & resend to MD\""
    }
  },
  {
    "id": "M10-L04",
    "moduleId": "M10",
    "number": 4,
    "title": "Find your sales orders and download the PDF",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Sales Orders\" — \"Your customer sales orders\".",
      "Company chips and From / To dates.",
      "Sort by \"Number\", \"Customer\", \"Date\", \"Total\".",
      "Badges \"Legacy\" and \"Rejection\".",
      "The download icon gives the branded PDF."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M10-L05",
    "moduleId": "M10",
    "number": 5,
    "title": "Read a sales order",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Click a row. \"Sales Order\" + number + status.",
      "\"01 Order Details\", \"02 Order Items\", \"03 Unloading Charges\".",
      "Linked \"Notes\" (credit / debit notes).",
      "\"Print\", \"PDF\", \"Existing Sale Order\". The page is read-only for sales."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M10-L06",
    "moduleId": "M10",
    "number": 6,
    "title": "Track your trucks on My Pipelines",
    "platform": "Web",
    "who": "All sales",
    "audience": "sales",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"My Pipelines\" — \"Read-only view\" · \"<n> trucks · owner: me\".",
      "Phase tabs: \"Full pipeline\", \"Preparing for dispatch\", \"In Transit\", …",
      "\"Search party, vendor, SO, product…\".",
      "Each card: dispatch number, kg, transporter, buyer, product, and the stage dots.",
      "\"Nothing is moving for you yet.\" until a deal of yours has a truck."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M11-L01",
    "moduleId": "M11",
    "number": 1,
    "title": "Apply for leave",
    "platform": "Web",
    "who": "Everyone",
    "audience": "everyone",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Initials → \"My HR\" → \"Leaves\". \"Leave Management\".",
      "\"+ New Request\": \"LEAVE TYPE\", \"FROM\", \"TO\". \"QUICK FILL\" helps.",
      "Write the reason.",
      "Click \"Submit request\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Submit request\""
    }
  },
  {
    "id": "M11-L02",
    "moduleId": "M11",
    "number": 2,
    "title": "Track and escalate a leave request",
    "platform": "Web",
    "who": "Everyone",
    "audience": "everyone",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"My Leaves\" lists your requests: \"PENDING\", \"APPROVED\", \"REJECTED\".",
      "Pending for over 48 h? Click \"Escalate\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Escalate\""
    }
  },
  {
    "id": "M11-L03",
    "moduleId": "M11",
    "number": 3,
    "title": "Read My Attendance and report a missing punch",
    "platform": "Web",
    "who": "Everyone",
    "audience": "everyone",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"My HR\" → \"My Attendance\".",
      "Pick the \"Month\". The calendar shows \"In HH:MM / Out HH:MM\" and the legend.",
      "\"Discipline — Flags\": 2 flags in a month mark you absent with a fine.",
      "Punch missing? \"Escalate to HR\" → \"Escalated\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Escalate to HR\""
    }
  },
  {
    "id": "M11-L04",
    "moduleId": "M11",
    "number": 4,
    "title": "Update your profile",
    "platform": "Web",
    "who": "Everyone",
    "audience": "everyone",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Initials → \"Profile\". \"My Profile\".",
      "\"Edit Profile\": first name, last name, phone. Email cannot change.",
      "Save."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M11-L05",
    "moduleId": "M11",
    "number": 5,
    "title": "Sign out of all devices",
    "platform": "Web",
    "who": "Everyone",
    "audience": "everyone",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On \"My Profile\" click \"Sign out everywhere\".",
      "\"Sign out of all devices\" — you are signed out here too.",
      "Use it if a phone is lost or you see \"already signed in\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "signs the demo login out"
    }
  },
  {
    "id": "M11-L06",
    "moduleId": "M11",
    "number": 6,
    "title": "Make a bug report and follow it (web)",
    "platform": "Web",
    "who": "Everyone",
    "audience": "everyone",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Initials → \"Report a bug\". The Resolution Centre opens.",
      "\"Report an issue\": \"Which module has the issue?\", \"How urgent is this?\", what went wrong.",
      "Send. Your ticket gets a TKT number.",
      "Tabs \"Active\" / \"Mine\" show your tickets and their status."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "sending"
    }
  },
  {
    "id": "M11-L07",
    "moduleId": "M11",
    "number": 7,
    "title": "Where to report a bug — phone or web",
    "platform": "Web",
    "who": "Everyone",
    "audience": "everyone",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On the phone: drawer → \"Report a bug\" (M07-L01).",
      "On the web: initials → \"Report a bug\" (M11-L06).",
      "Both land in the same Resolution Centre; the admin team answers there."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "rules"
    }
  },
  {
    "id": "M12-L01",
    "moduleId": "M12",
    "number": 1,
    "title": "Your purchase home: the Purchase Cockpit",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "After sign-in \"Purchase Cockpit\" — \"Pick up an enquiry. Get rates. Move the deal forward.\". \"↻ Refresh\".",
      "\"Needs your action\" lists enquiries; \"Search enquiry, commodity or city\", \"All Purchase\" / \"My work\", \"Most overdue first\", \"Overdue only\", \"Reset filters\".",
      "Each row: quantity, \"Next step / last saved action\", time waiting, and the next-action button (e.g. \"Get vendor rates\").",
      "\"Open Deal Desk\" opens the full list."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M12-L02",
    "moduleId": "M12",
    "number": 2,
    "title": "Read your own numbers on the cockpit",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"{n} need Purchase action\", \"{n} past step deadline\", \"{n} with MD\".",
      "Queue tiles: \"Get vendor rates\", \"Renegotiation\", \"Saved, not sent to MD\", \"With MD\".",
      "\"Waiting on MD\" card → \"View submitted deal\" / \"View MD queue (n)\".",
      "All times are IST; \"Waiting\" is time in the current step."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M12-L03",
    "moduleId": "M12",
    "number": 3,
    "title": "Check today's rate coverage",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Rates to collect today\" — \"Check rates before you quote a buyer.\"",
      "\"{x} of {y} vendors updated today\" per commodity.",
      "\"Open Rate Book\" to fill the gaps (PM edits; PH sees it read-only)."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M12-L04",
    "moduleId": "M12",
    "number": 4,
    "title": "Rules: who decides what in purchase",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Purchase finds the vendor and freight and builds the deal options.",
      "MD approves the margin; Purchase never approves its own deal.",
      "A negative-margin option must be escalated to MD before submit.",
      "Once MD approves, only admin can cancel or undo a PO.",
      "Rejection settlements and vendor debit notes are admin + MD only.",
      "A purchase-raised enquiry gets its salesperson from the delivery state; if none, MD assigns it in Lead Triage."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "rules"
    }
  },
  {
    "id": "M13-L01",
    "moduleId": "M13",
    "number": 1,
    "title": "Fill today's vendor rates in the Rate Book",
    "platform": "Web",
    "who": "Purchase (PM)",
    "audience": "purchasePM",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Rate Book\" — \"Today-first vendor rates\". Pick a product on the rail.",
      "\"{x} of {y} vendors covered today\" — a \"no stock\" reply counts.",
      "\"More filters (vendor type, city, scope, search, dates)\".",
      "Type today's ₹/kg in the pink cell; it saves when you leave the box.",
      "\"history ▸\" shows past quotes."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "typing a rate"
    }
  },
  {
    "id": "M13-L02",
    "moduleId": "M13",
    "number": 2,
    "title": "Map plants to commodities",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Mapping\" — \"Commodity Mapping Manager\" with coverage.",
      "Tabs \"all\" / \"unmapped\" / \"mapped\"; category chips; \"Search name or city…\", \"Callable only\".",
      "\"+\" on a plant → \"Add commodities\". ✕ on a chip removes it.",
      "Tick plants → \"Bulk map:\" → \"Choose commodities…\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M13-L03",
    "moduleId": "M13",
    "number": 3,
    "title": "Keep the Trade Network clean",
    "platform": "Web",
    "who": "Purchase (PM)",
    "audience": "purchasePM",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Trade Network\" — tabs \"Vendors\", \"Transporters\", \"Parties\".",
      "\"Missing phone only\" shows what to fix. Click a phone cell to edit → \"Save\".",
      "\"Unarchive\" brings back an archived row.",
      "\"Delete\" checks usage first — read the dialog.",
      "\"+ New customer\" opens the customer form."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save\" / \"Delete\""
    }
  },
  {
    "id": "M13-L04",
    "moduleId": "M13",
    "number": 4,
    "title": "Create a vendor",
    "platform": "Web",
    "who": "Purchase (PM)",
    "audience": "purchasePM",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Vendors\" → \"New Vendor\".",
      "\"Start with GSTIN\" → verify, or \"Skip — enter manually (unregistered vendor)\".",
      "\"Vendor Identity\", \"GST & PAN\", \"Financial Details\", scorecard.",
      "\"Next\": \"Vendor Tags\", \"Assign Managers\"; \"Addresses\" with \"Plant city — freight origin\"; \"Contact Information\".",
      "\"Save Vendor\"."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save Vendor\""
    }
  },
  {
    "id": "M13-L05",
    "moduleId": "M13",
    "number": 5,
    "title": "Create a transporter",
    "platform": "Web",
    "who": "Purchase (PM)",
    "audience": "purchasePM",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Transporters\" → \"New Transporter\".",
      "\"GST Number\" + \"Verify\".",
      "\"Transport Information\", \"Vehicle & Fleet\", \"Service Routes\" (add lanes).",
      "\"Tags & Managers\", \"Billing Address\", \"Compliance Documents\".",
      "\"Save Transport\"."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save Transport\""
    }
  },
  {
    "id": "M13-L06",
    "moduleId": "M13",
    "number": 6,
    "title": "Add bank details and scan a PAN card",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On a vendor or transporter click \"+ Add / edit bank details\" (save the party first).",
      "\"Bank details\": \"📷 Scan cancelled cheque (JPG) to auto-fill\", or type \"Account number\", \"IFSC\", \"Holder name\", \"Bank\", \"Branch\".",
      "\"Save bank details\".",
      "\"📷 Scan PAN card (JPG)\" reads the PAN."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M13-L07",
    "moduleId": "M13",
    "number": 7,
    "title": "Add trucks, drivers and contacts to a transporter",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Open the transporter → \"Fleet\".",
      "\"Add truck\" → \"New truck\".",
      "\"Add driver\" → \"Name *\", \"Phone *\" → \"Save driver\".",
      "\"Add contact\" → name, phone, role."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M13-L08",
    "moduleId": "M13",
    "number": 8,
    "title": "Set up a godown rent card",
    "platform": "Web",
    "who": "Purchase (PM)",
    "audience": "purchasePM",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Godowns\" — \"A godown is a rent card with a name.\"",
      "\"New godown\": GSTIN + \"Verify\", name, address, city.",
      "\"Rent per day (₹)\", \"Minimum days\".",
      "\"Save godown\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save godown\""
    }
  },
  {
    "id": "M13-L09",
    "moduleId": "M13",
    "number": 9,
    "title": "Add or edit a product",
    "platform": "Web",
    "who": "Purchase (PM)",
    "audience": "purchasePM",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Products\" — search, \"All categories\".",
      "\"New Product\": \"Product Name *\", subname, \"Type of Supply *\", HSN, category, GST rate.",
      "Edit a product the same way."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M14-L01",
    "moduleId": "M14",
    "number": 1,
    "title": "Find a customer",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Customers\" — \"Customer Master\".",
      "Search, status tabs, \"{n} customers\".",
      "Click a row: \"Identity\", \"Contact & Terms\", \"History\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M14-L02",
    "moduleId": "M14",
    "number": 2,
    "title": "Create a customer from the GSTIN",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"+ New Customer\" → \"New party\".",
      "\"GSTIN\" → \"Verify\", or tick \"Unregistered / B2C customer (no GSTIN)\".",
      "Phone, email, payment terms, contacts (mobile required), address.",
      "\"Create customer\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Create customer\""
    }
  },
  {
    "id": "M14-L03",
    "moduleId": "M14",
    "number": 3,
    "title": "Upload the customer's KYC",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"KYC documents — {name}\".",
      "PAN with \"📷 Scan PAN card (JPG)\", GST certificate.",
      "\"Optional documents & photo\"; \"+ Add bank details\".",
      "\"Your role isn't allowed to upload KYC documents — ask an admin.\" means ask admin."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "upload"
    }
  },
  {
    "id": "M14-L04",
    "moduleId": "M14",
    "number": 4,
    "title": "Edit a customer's addresses",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Billing / shipping address\" → \"Edit\".",
      "\"Delivery addresses\" → \"+ Add\".",
      "The remove icon deletes one."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M15-L01",
    "moduleId": "M15",
    "number": 1,
    "title": "Raise a new enquiry from the Deal Desk list",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"+ New Enquiry\".",
      "\"Party *\", \"Commodity *\", \"Grade (optional)\", \"Quantity (kg) *\", target price, delivery State → City.",
      "\"Advanced Options\", \"Payment term\", \"Expected delivery\".",
      "\"Create Enquiry\". You own the purchase side; the salesperson comes from the delivery state, or MD assigns one."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Create Enquiry\""
    }
  },
  {
    "id": "M15-L02",
    "moduleId": "M15",
    "number": 2,
    "title": "Find enquiries on the Deal Desk list",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Veda Agro — Requirements\" (your menu may call it \"Deal Desk\").",
      "\"{n} deals decided\" strip; status tabs from \"Looking to Purchase\".",
      "\"Search enquiries...\"; \"Grade: <x>\" under the commodity.",
      "Click a row to open the Deal Desk."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M15-L03",
    "moduleId": "M15",
    "number": 3,
    "title": "Read an enquiry on the Deal Desk",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"← Requirements\" · \"Deal Desk\"; \"Work\" / \"Historical\".",
      "Header: number, step, status; MD banner if MD has decided.",
      "\"Quantity\", \"Deliver to\", \"Buyer target\".",
      "\"Coverage\", \"Live Margin\", \"Total\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M15-L04",
    "moduleId": "M15",
    "number": 4,
    "title": "Use the recommendation and compare plants",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Recommended sourcing\": \"Single best plant\" or \"Blended coverage plan\".",
      "\"Start from the most profitable mix\".",
      "\"Compare candidates\": \"−\" / \"+\" trucks, ✕ to remove.",
      "\"+ Add {n trucks}\" or \"+ Add all costed to deal\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"+ Add\""
    }
  },
  {
    "id": "M15-L05",
    "moduleId": "M15",
    "number": 5,
    "title": "Choose a plant, or add a new one",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"1 Choose a plant\" — ranked by margin; the cheapest landed cost wins.",
      "\"Radius\"; \"Add a plant by name…\".",
      "New plant: \"GSTIN\" → \"Verify & autofill\", or \"Skip — enter manually\".",
      "\"Add plant\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Add plant\""
    }
  },
  {
    "id": "M15-L06",
    "moduleId": "M15",
    "number": 6,
    "title": "Choose a transporter and save the option",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"2 Choose a transporter\".",
      "Vendor rate, \"Pickup\"; \"Add a transporter by name…\".",
      "\"No transport\" (self-pickup / FOR) or a transporter row; \"+ Log freight rate\".",
      "\"Quantity for this option\", GST.",
      "\"Finalise & save option\"."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Finalise & save option\""
    }
  },
  {
    "id": "M15-L07",
    "moduleId": "M15",
    "number": 7,
    "title": "Cover a deal from a rejected lot",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Mode \"Cover from a rejected lot\".",
      "\"Available rejected lots\" — search.",
      "\"Quantity to cover (kg)\", \"Sell price (₹/kg)\".",
      "\"Cover {kg} kg from this lot\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Cover\""
    }
  },
  {
    "id": "M15-L08",
    "moduleId": "M15",
    "number": 8,
    "title": "Edit, confirm, escalate or remove a saved option",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Saved deal options\".",
      "\"Edit\" → qty + rate → \"Save\".",
      "\"Confirm rate\" — the rate still holds.",
      "\"Escalate\" a negative-margin option to MD.",
      "Trash = \"Remove option\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "each button"
    }
  },
  {
    "id": "M15-L09",
    "moduleId": "M15",
    "number": 9,
    "title": "Confirm the buyer target and submit to MD",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Tick \"Confirm buyer target ₹x/kg\".",
      "Click \"Submit to MD\".",
      "Errors tell you what blocks it, e.g. an open renegotiation with Sales."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Submit to MD\""
    }
  },
  {
    "id": "M15-L10",
    "moduleId": "M15",
    "number": 10,
    "title": "Change the customer's quantity or unlock a PO quantity",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Open \"Quantity\": \"Customer ordered\" vs \"Bought from suppliers\".",
      "\"Coverage\" shows the result before saving.",
      "\"Unlock quantity {PO}\" → read the warning → type the new kg → save."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M15-L11",
    "moduleId": "M15",
    "number": 11,
    "title": "Look up past deals in Historical",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Toggle \"Historical\".",
      "\"Total Purchase\", \"Total Selling\", \"Total Profit\", \"Deals\".",
      "\"Commodity…\", \"Search buyer / SO…\". Same view on the Allocation Board."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M15-L12",
    "moduleId": "M15",
    "number": 12,
    "title": "Cancel a purchase order and restore it",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On the list click the ban icon \"Cancel an order on {number}\".",
      "Choose the one PO; \"Cancel this purchase order?\" + reason.",
      "The undo icon \"Restore a cancelled order\" works within 7 days.",
      "Once MD approved the deal both are admin-only (\"MD-approved — only admin can cancel\")."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirming"
    }
  },
  {
    "id": "M16-L01",
    "moduleId": "M16",
    "number": 1,
    "title": "Answer an MD send-back and resubmit",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"MD sent this deal back — with {who}\" and the reasons.",
      "\"Your options (edit costs)\": purchase, freight.",
      "Or \"Change plant / transporter\".",
      "\"Resubmit to MD\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Resubmit to MD\""
    }
  },
  {
    "id": "M16-L02",
    "moduleId": "M16",
    "number": 2,
    "title": "Respond to an open renegotiation",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Banners \"Sales accepted your ask…\" / \"Renegotiation in progress\".",
      "\"On it — ETA:\" chips.",
      "Type the vendor rate / freight / sell price.",
      "\"Confirm & resend to MD\", or \"Rebuild instead …\".",
      "\"Renegotiation history\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Confirm & resend to MD\""
    }
  },
  {
    "id": "M16-L03",
    "moduleId": "M16",
    "number": 3,
    "title": "Ask Sales or Logistics for a better number",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Under the option: \"Freight lane\" / \"Renegotiate\".",
      "Footer \"Send to freight lane\" → \"⏳ Freight requested\".",
      "Footer \"Send to Sales · renegotiate\" → new target and reason."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "sending"
    }
  },
  {
    "id": "M16-L04",
    "moduleId": "M16",
    "number": 4,
    "title": "Work the Renegotiate inbox",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Renegotiate\": KPIs \"Awaiting me\", \"Raised\", \"Under review\".",
      "\"Requirements awaiting purchase\"; stage chips.",
      "Open one: \"Target sell\", \"Options\", \"Total margin\", \"Profitability by option\".",
      "\"Mark under review\", \"Send re-negotiate\", \"Route to logistics\", \"Send to MD\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "each action"
    }
  },
  {
    "id": "M16-L05",
    "moduleId": "M16",
    "number": 5,
    "title": "Track open renegotiations",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Renegotiations\" (with a count) — \"Refresh\".",
      "Columns: enquiry and round, commodity, \"Sent back by\".",
      "\"Open →\" takes you to the Deal Desk."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M17-L01",
    "moduleId": "M17",
    "number": 1,
    "title": "Find orders and download PDFs",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Veda Agro — Contracts\" (or \"Orders\" / \"Sales Orders\" in your menu).",
      "Tabs \"Sales Orders\" / \"Purchase Orders\"; company chips; dates. Sales orders are not yours to see — that tab says \"Sales orders are visible to sales and accounts\".",
      "Tags \"Legacy\", \"Rejection\". Download icon = branded PDF."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M17-L02",
    "moduleId": "M17",
    "number": 2,
    "title": "Create a manual purchase order",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"+ New PO\".",
      "\"Company *\", \"01 Purchase Order Details\", \"Vendor *\".",
      "Bill From / Ship From; \"Payment Terms *\".",
      "\"02 Purchase Items\", \"03 Unloading Charges\", \"04 Purchase Summary\", \"05 Terms & Conditions\".",
      "\"Create PO\". MD activates it on the Margin Desk."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Create PO\""
    }
  },
  {
    "id": "M17-L03",
    "moduleId": "M17",
    "number": 3,
    "title": "Create a manual sales order",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"+ New SO\".",
      "\"Finalization Lead\" links an enquiry.",
      "\"Supply Source\": \"Vendor (normal)\" or \"Rejected lot\".",
      "\"Customer *\", Bill To / Ship To, \"02 Order Items\".",
      "\"Confirm Order\"."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Confirm Order\""
    }
  },
  {
    "id": "M17-L04",
    "moduleId": "M17",
    "number": 4,
    "title": "Record a legacy (pre-AURA) sales order",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On the SO form turn on \"Legacy deal (pre-AURA)\".",
      "Type the \"Old contract / serial no.\".",
      "Fill the order as usual and confirm."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirming"
    }
  },
  {
    "id": "M18-L01",
    "moduleId": "M18",
    "number": 1,
    "title": "Read the Allocation Board",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "The banner: \"To fill open demand, press Allocate leftover on a purchase order and pick the sales order.\"",
      "\"Profit Allocation\" / \"Historical\"; \"Total bought\", \"Allocated\".",
      "\"Quantity\" / \"Purchase ₹\" / \"Sale ₹\"; search.",
      "SO cards: \"SO profit\", \"Blended\", PO legs."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M18-L02",
    "moduleId": "M18",
    "number": 2,
    "title": "Allocate leftover kg and set a status",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Status chip \"Planned\" / \"Confirmed\" / \"At risk\" / \"Fulfilled\".",
      "\"⚡ Allocate leftover · {kg} kg\" → pick the SO.",
      "\"Allocate {kg} kg\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Allocate\""
    }
  },
  {
    "id": "M18-L03",
    "moduleId": "M18",
    "number": 3,
    "title": "Raise a new dispatch",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"New dispatch\" (or \"+ Add dispatch\").",
      "\"1. Order\" → \"2. Quantity\" (kg, vehicle optional) → \"3. Confirm\".",
      "The bar moves only when S4 Loading has a weighbridge reading."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirming"
    }
  },
  {
    "id": "M18-L04",
    "moduleId": "M18",
    "number": 4,
    "title": "Close a truck or a procurement, or cancel a part-fulfilled deal",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Close unfulfilled\" → why.",
      "Open a PO: \"Close {PO} with {kg} still to load?\" → \"Close procurement\".",
      "\"Cancel deal · part fulfilled\" — only on your own deals."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirming"
    }
  },
  {
    "id": "M18-L05",
    "moduleId": "M18",
    "number": 5,
    "title": "Undo a PO to change the plant",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Open the PO → \"Undo {PO} — change the plant?\".",
      "Read the blockers.",
      "\"Undo PO\". After MD approval only admin can."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Undo PO\""
    }
  },
  {
    "id": "M19-L01",
    "moduleId": "M19",
    "number": 1,
    "title": "Follow your trucks on My Pipelines",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"PURCHASE · MY PIPELINES\".",
      "Phase tabs, \"👁 Read-only view\", search.",
      "Truck cards with vendor → buyer and the stage."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M19-L02",
    "moduleId": "M19",
    "number": 2,
    "title": "Review rejected dispatches",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Rejected Dispatches\" — every truck ended at Quality Check.",
      "Search; \"Rejected on\", \"Rejected by\", \"Fault\".",
      "Settlement chip. \"Open on Holding Desk\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M19-L03",
    "moduleId": "M19",
    "number": 3,
    "title": "See held lots on the Holding Desk",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Holding Desk\" opens on \"Lots\".",
      "Search; \"Open\" / \"Closed\".",
      "Each lot: where it is and \"Holding cost so far ₹x\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M19-L04",
    "moduleId": "M19",
    "number": 4,
    "title": "Open a held lot",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Operations · Holding Desk\" + lot number + state.",
      "\"Held\", \"Spent so far\", \"Where it is\".",
      "\"Legs — every move this lot has made\".",
      "\"What can happen next\"; \"Find a buyer →\"; \"{buyer} takes it after all →\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M19-L05",
    "moduleId": "M19",
    "number": 5,
    "title": "Hand a held lot to a new transporter",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Swap transporter\" → \"Hand the load to a new transporter\".",
      "Papers required; weighing block.",
      "\"Outgoing dues\", \"Payment UTR\".",
      "\"Start the leg\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Start the leg\""
    }
  },
  {
    "id": "M19-L06",
    "moduleId": "M19",
    "number": 6,
    "title": "Ask to put a lot in a godown",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Ask to open a godown\" → \"Put the goods on the ground\".",
      "It is MD's decision; MD approves the grounding.",
      "\"Record the grounding\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "recording"
    }
  },
  {
    "id": "M19-L07",
    "moduleId": "M19",
    "number": 7,
    "title": "Send a lot back to the plant",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Send the load back to the plant\".",
      "Holding claim \"Claim from the plant\" / \"Veda absorbs\".",
      "\"Send back\" → \"Sent back to the plant\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send back\""
    }
  },
  {
    "id": "M19-L08",
    "moduleId": "M19",
    "number": 8,
    "title": "Record lot expenses",
    "platform": "Web",
    "who": "Purchase",
    "audience": "purchase",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"What holding it has cost\" → \"Lot expenses\".",
      "\"+ Add expense\".",
      "Edit or delete a row."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M20-L01",
    "moduleId": "M20",
    "number": 1,
    "title": "Read the Logistics Cockpit",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Logistics Cockpit\" + date and time. \"Open Dispatch Tracker\", \"Open Allocation Board\", \"Open Trade Routes\".",
      "\"Where every truck is — true walk order. Click a box to open the Dispatch Tracker.\"",
      "\"Do this now\" — one row per truck, grouped: \"Confirm freight\", \"Complete truck papers\", \"Record loading & send off\", \"On the road\", \"Reached — record delivery\".",
      "\"Open in Dispatch Tracker →\" on a row."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M20-L02",
    "moduleId": "M20",
    "number": 2,
    "title": "Read your own numbers",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Need me now\" — trucks at a logistics stage.",
      "\"Stuck 3+ days\".",
      "\"On the road\" — S8 Transit.",
      "\"Trucks to add\" — PO mapped to an SO, kg still unplanned.",
      "\"With Accounts\" — sale bill, purchase bill, settlement."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M20-L03",
    "moduleId": "M20",
    "number": 3,
    "title": "Add a truck, and see what Accounts holds",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Add a truck\" card → \"Add truck on Allocation Board →\" opens the wizard on that PO.",
      "Fold \"With Accounts, not you\" → \"View in Dispatch Tracker →\".",
      "Fold \"Freight to confirm on new enquiries\" → \"Open Freight Desk →\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M20-L04",
    "moduleId": "M20",
    "number": 4,
    "title": "Rules: walk order and the 5-quote rule",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "A truck walks S1 → S2 → S3 → S6 (QC) → S4 → S5 → S7 → S8 → S9 → S10 → S11.",
      "A gate blocks \"Advance stage\" until its papers are on file.",
      "Collect 5 transporter quotes before locking a lane. With fewer, the app warns \"Only N quotes — lock anyway?\".",
      "Rejection settlements are admin + MD; you record holding costs only.",
      "Purchase cost and margin are not shown to logistics."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "rules"
    }
  },
  {
    "id": "M21-L01",
    "moduleId": "M21",
    "number": 1,
    "title": "Confirm freight on the Freight Desk",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Freight Desk\" — \"{n} waiting\".",
      "Search; \"Freight to confirm\" → pick a deal.",
      "\"Freight detail\", \"Rate comparison\".",
      "Select the transporter, type ₹/kg.",
      "\"Lock & send to Purchase\" (or \"Lock & send to MD\" on a bounced deal)."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Lock & send\""
    }
  },
  {
    "id": "M21-L02",
    "moduleId": "M21",
    "number": 2,
    "title": "Answer a freight renegotiation",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Card \"freight · reneg\" with the target.",
      "Pick \"accepted\", \"counter\", \"declined\" or \"updated\".",
      "\"New freight ₹/kg\", \"Note (optional)\".",
      "\"Submit response\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Submit response\""
    }
  },
  {
    "id": "M21-L03",
    "moduleId": "M21",
    "number": 3,
    "title": "Answer an MD freight send-back",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Cockpit card \"Confirm freight — MD asked\" → \"Answer freight ask →\".",
      "\"MD sent this back — Freight rate needed\".",
      "\"On it — ETA:\".",
      "\"Freight rate (₹/kg)\"; ₹0 needs a reason.",
      "\"Confirm & resend to MD\". Back returns to the Logistics Cockpit."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Confirm & resend to MD\""
    }
  },
  {
    "id": "M22-L01",
    "moduleId": "M22",
    "number": 1,
    "title": "Trade Routes: dispatch board and pipeline",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Trade Routes\" — tabs \"Dispatch\", \"Rate Updates\", \"Pipeline\".",
      "\"Dispatch\": \"My Trucks\", \"In Progress\", \"Blocked\", \"My Pending\", \"Avg Completion\"; Truck / Vehicle columns.",
      "\"Pipeline\": kanban; cards read \"Truck: DSP-…\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M22-L02",
    "moduleId": "M22",
    "number": 2,
    "title": "Collect transporter quotes on a lane",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Rate Updates\": search, heat pills, status pills, \"Radius\".",
      "Open a lane: \"{origin} to {destination} freight\".",
      "\"Find a transporter\"; \"{n} of 5 transporters logged\".",
      "Type the rate → \"Log\"; \"✓ Logged\" → \"Re-log\".",
      "\"Doesn't serve\"; \"+ Add\" a transporter not in the list."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Log\""
    }
  },
  {
    "id": "M22-L03",
    "moduleId": "M22",
    "number": 3,
    "title": "Lock a lane and send it to Purchase",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "With 5 quotes \"Lock & send to Purchase\" is live.",
      "With fewer, it warns \"Only N quotes — lock anyway?\".",
      "Confirm only when the lane really has no more transporters."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirming"
    }
  },
  {
    "id": "M22-L04",
    "moduleId": "M22",
    "number": 4,
    "title": "Look up freight history on any lane",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Look up any lane's freight history\".",
      "\"Origin\" → \"Destination\" + radius.",
      "Read the history."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M22-L05",
    "moduleId": "M22",
    "number": 5,
    "title": "Browse the Transporter Ledger",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Transporter Ledger ({total})\": search, type and status chips.",
      "Open one: \"Basic Info\", \"GST & PAN\", \"Validity Dates\".",
      "\"Route Mapping →\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M22-L06",
    "moduleId": "M22",
    "number": 6,
    "title": "Map a transporter's routes",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Route Mapping — {name}\".",
      "\"Origin\", \"Destination\", \"Rate/kg (₹)\" → add.",
      "\"Edit\" → \"Update\" / \"Cancel\"; \"Delete\" → \"Delete this route?\".",
      "\"Bulk CSV Import\": origin,destination,ratePerKg."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M23-L01",
    "moduleId": "M23",
    "number": 1,
    "title": "Read the Allocation Board",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Banner, \"Profit Allocation\" / \"Historical\". \"Profit and margin are not shown to your role\" — no profit tiles for logistics.",
      "\"Quantity\" / \"Purchase ₹\" / \"Sale ₹\"; search.",
      "\"Ordered\", \"Fulfilled\", \"Unfulfilled\", \"Behind\"; book strip.",
      "SO cards, \"Ledger\" / \"Lanes\", PO legs."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M23-L02",
    "moduleId": "M23",
    "number": 2,
    "title": "Raise a new dispatch",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"New dispatch\" or \"+ Add dispatch · {n} kg uncommitted\".",
      "\"1. Order\" → \"2. Quantity\" → \"3. Confirm\".",
      "\"Raise dispatch\" → \"{DSP} raised against {PO}. Its stage tracker has started at S1 Deal capture.\""
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Raise dispatch\""
    }
  },
  {
    "id": "M23-L03",
    "moduleId": "M23",
    "number": 3,
    "title": "Close a truck unfulfilled or remove a truck",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Truck line under a PO.",
      "\"Close unfulfilled\" → why.",
      "\"Remove truck\" (S1–S3 only) → read the warning."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirming"
    }
  },
  {
    "id": "M23-L04",
    "moduleId": "M23",
    "number": 4,
    "title": "Allocate leftover kg and set a status",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Status menu \"Planned\" / \"Confirmed\" / \"At risk\" / \"Fulfilled\".",
      "Expand: \"Loaded\" bar, margin box.",
      "\"Allocate leftover · {n} kg\" → \"Allocate {n} kg\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Allocate\""
    }
  },
  {
    "id": "M23-L05",
    "moduleId": "M23",
    "number": 5,
    "title": "Close procurement or cancel a part-fulfilled deal",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Click a PO → order focus panel; \"Back to the board\".",
      "\"Close {PO} with {kg} kg still to load?\" → \"Close procurement\".",
      "\"Cancel the whole deal?\" → \"Cancel deal · part fulfilled\" → why."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirming"
    }
  },
  {
    "id": "M23-L06",
    "moduleId": "M23",
    "number": 6,
    "title": "Look up settled deals",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Historical\": \"From\", \"To\", \"Commodity…\", \"Search buyer / SO…\" → \"Apply\".",
      "\"Deals\", \"Total Purchase\", \"Total Selling\", \"Total Profit\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M24-L01",
    "moduleId": "M24",
    "number": 1,
    "title": "Track every truck in My Pipelines",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"LOGISTICS · MY PIPELINES\" — \"{n} trucks · everyone\".",
      "Phase tabs; search.",
      "Truck cards with the stage."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M24-L02",
    "moduleId": "M24",
    "number": 2,
    "title": "Read the Delivery Pipeline",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Menu \"Delivery Pipeline\".",
      "Phase tabs + \"Delivered\"; \"Cards\" / \"Table\"; search.",
      "\"Purchase cost, sale value and margin are not shown to your role. Trucks, stages and documents are.\"",
      "Open a truck: \"Loaded\", \"Unloaded\", \"Shortage\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M25-L01",
    "moduleId": "M25",
    "number": 1,
    "title": "Find a truck and read its card",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Logistics · Dispatch Tracker\"; \"Stage\" select.",
      "\"{n} trucks at this stage\"; search.",
      "Truck card: \"{DSP} · {plate} · {kg} kg planned\"; expand.",
      "Drawer: \"Current stage\", stepper, documents."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M25-L02",
    "moduleId": "M25",
    "number": 2,
    "title": "Advance a truck and clear its gates",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Compliance gate — blocked until docs are on file\".",
      "Upload / type each field → \"Save\".",
      "\"✓ All gates clear — ready to advance\".",
      "\"Advance stage\". A refusal shows next to the button."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Advance stage\""
    }
  },
  {
    "id": "M25-L03",
    "moduleId": "M25",
    "number": 3,
    "title": "S1 Deal capture",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Deal contacts: \"Customer contact\", \"Vendor contact\" → \"Attach contact…\"; eye shows a number.",
      "\"Customer PAN\" / \"Vendor PAN\" + upload.",
      "\"Customer GST\" / \"Vendor GST\" → \"Save\".",
      "\"Vendor payment terms\", \"Customer payment terms\", \"Transport payment terms\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M25-L04",
    "moduleId": "M25",
    "number": 4,
    "title": "S2 Confirm freight, transporter contact and halting",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Freight already agreed\".",
      "\"Freight per kg\" → \"Confirm freight\".",
      "\"Transporter\" → \"Unlock to edit\"; \"Transporter Contact Number\" → \"Save\".",
      "\"Halting Rate (₹/day)\" or a new slab.",
      "\"Consent form\" (optional)."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M25-L05",
    "moduleId": "M25",
    "number": 5,
    "title": "S2 Change the transporter on a truck",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Change transporter\" — read the warning.",
      "Pick the new transporter.",
      "Save."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M25-L06",
    "moduleId": "M25",
    "number": 6,
    "title": "S2 Add a transporter that is missing",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "No match? Click \"Add a transporter\" — it opens in a new tab.",
      "\"Create Transporter\": GST, name, type, documents.",
      "\"Fleet\": \"Add truck\", \"Add driver\", \"Add contact\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M25-L07",
    "moduleId": "M25",
    "number": 7,
    "title": "S3 Truck papers",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Vehicle Number\".",
      "\"TPT Bilty\", \"Vehicle RC\", \"Driving License\".",
      "\"Transporter PAN\".",
      "\"Driver Contact Number\" or \"Same as transporter contact\".",
      "Optional \"Cancelled Cheque\", \"TDS / Lower-deduction Cert\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "upload"
    }
  },
  {
    "id": "M25-L08",
    "moduleId": "M25",
    "number": 8,
    "title": "S3 Record the transporter's bank account",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Transporter Bank Account\" → type the account the first time.",
      "On file it shows masked: \"To change it, ask an admin.\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M25-L09",
    "moduleId": "M25",
    "number": 9,
    "title": "S6 Quality check and Reject lot",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Product Photos\", \"Product Video\".",
      "\"Reject lot\" → \"This ends this truck…\".",
      "\"Transporter settlement\" part amount.",
      "\"Reject lot and send for approval\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "rejecting"
    }
  },
  {
    "id": "M25-L10",
    "moduleId": "M25",
    "number": 10,
    "title": "S4 Loading and dispatch",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Upload \"Loading Slip\".",
      "\"Net loading weight (kg)\".",
      "\"Dispatch Date\" (not in the future)."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M25-L11",
    "moduleId": "M25",
    "number": 11,
    "title": "S5 Sale bill and payments",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Upload \"Sale Invoice\" + references, or \"Generate Sale Invoice\" → \"Confirm & Generate\".",
      "\"E-Way Bill\" upload + number.",
      "Transporter advance; \"Plant Full Payment\" + \"UTR\".",
      "\"Vendor Bank Account\"; \"Transporter due — ₹{x}\"."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Confirm & Generate\""
    }
  },
  {
    "id": "M25-L12",
    "moduleId": "M25",
    "number": 12,
    "title": "S7 Purchase bill",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Upload \"Purchase Invoice - from vendor\" + references.",
      "Check \"Expected from {vendor} ({PO})\".",
      "\"E-Way Bill - from vendor\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M25-L13",
    "moduleId": "M25",
    "number": 13,
    "title": "S8 Transit and S9 destination QC",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "S8 has no fields; \"Advance stage\" when the truck reaches.",
      "S9: \"Destination Photos\", \"Destination Video\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "advancing"
    }
  },
  {
    "id": "M25-L14",
    "moduleId": "M25",
    "number": 14,
    "title": "S9 The buyer refused the load",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Buyer refused load\".",
      "\"This ends {DSP} at the gate.\" Weights.",
      "\"Why did they refuse it? *\".",
      "\"Buyer refused load\" to submit, or \"Cancel\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "submit"
    }
  },
  {
    "id": "M25-L15",
    "moduleId": "M25",
    "number": 15,
    "title": "S10 Delivery and unloading",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Delivery Receipts\", \"Delivery date\", \"Net unloading weight (kg)\".",
      "Read \"Shortage: {x} · Allowed: {kg} kg · Over by …\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M25-L16",
    "moduleId": "M25",
    "number": 16,
    "title": "S11 Final settlement",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Shortage box; spillage due.",
      "\"Transporter Final Payment\" + UTR + amount.",
      "\"Halting charges applied?\" → slip.",
      "Credit note to the customer for shortage.",
      "\"Settlement Charges\" → \"Submit for MD sign-off\"."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "submit"
    }
  },
  {
    "id": "M25-L17",
    "moduleId": "M25",
    "number": 17,
    "title": "Fix mistakes: move back, override a gate, delete a file",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Move back\" + reason (permanent).",
      "Correct a done stage with \"why? (optional)\".",
      "\"Delete\" a wrong file — it stays in storage.",
      "\"Override this gate\" with a reason."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirming"
    }
  },
  {
    "id": "M25-L18",
    "moduleId": "M25",
    "number": 18,
    "title": "FOR trucks (vendor delivers)",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"FOR · ₹0 freight\" — \"Vendor delivers this truck. Transporter steps are optional\".",
      "\"Add transporter\" / \"Change transporter\" if one is used after all."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M25-L19",
    "moduleId": "M25",
    "number": 19,
    "title": "Flag a transporter or remove a truck",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Flag transporter\" → reason.",
      "\"Remove truck\" (S1–S3 only) → read the warning."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "confirming"
    }
  },
  {
    "id": "M26-L01",
    "moduleId": "M26",
    "number": 1,
    "title": "Report a truck breakdown",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "On an S8 truck: \"Report truck breakdown\".",
      "\"Location pincode\" → \"Location found.\"",
      "Reason; \"Start emergency\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Start emergency\""
    }
  },
  {
    "id": "M26-L02",
    "moduleId": "M26",
    "number": 2,
    "title": "Replacement truck and resume the journey",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Truck breakdown\" — \"Emergency active · Transit\".",
      "\"Replacement truck\": vehicle, transporter.",
      "\"Updated documents\": Sale Invoice, E-Way Bill uploads.",
      "\"Save emergency\" → \"Resume journey\".",
      "\"Journey resumed · {plate}\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Resume journey\""
    }
  },
  {
    "id": "M26-L03",
    "moduleId": "M26",
    "number": 3,
    "title": "Send breakdown costs to MD",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Extra costs · MD approval\".",
      "Freight for the replacement, dues to the original transporter, godown.",
      "\"Save costs\" → \"Send to MD\".",
      "Read MD's answer: approved or rejected."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send to MD\""
    }
  },
  {
    "id": "M27-L01",
    "moduleId": "M27",
    "number": 1,
    "title": "Review a rejected dispatch",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Rejected Dispatches\" — search.",
      "\"Lot rejected at Quality Check\" + reason; \"Rejected on\", \"Rejected by\".",
      "\"Open on Holding Desk\" opens the lot list (\"Lots\")."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M27-L02",
    "moduleId": "M27",
    "number": 2,
    "title": "Record holding costs on a lot",
    "platform": "Web",
    "who": "Logistics",
    "audience": "logistics",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Open the lot: \"Operations · Holding Desk\".",
      "\"Add expense\" → type, basis, amount.",
      "The expenses table."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M28-L01",
    "moduleId": "M28",
    "number": 1,
    "title": "Your home: the Accounts Cockpit",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "You land on \"Accounts Cockpit\".",
      "Sidebar sections \"Books\", \"Compliance\", \"Reports\" and \"See more\".",
      "\"Open Dispatch Tracker\", \"Open Books ledger\".",
      "Queues \"Raise sale bill & pay the plant\", \"Record the plant's purchase bill\", \"Close the settlement\" with row buttons.",
      "Initials menu: \"Profile\", \"Settings\", \"My HR\", \"Report a bug\", \"Logout\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M28-L02",
    "moduleId": "M28",
    "number": 2,
    "title": "Read your own numbers",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Sale bills to raise\".",
      "\"Purchase bills to record\".",
      "\"Settlements to close\".",
      "\"Payments to make\" — a plant, transporter or final UTR still blank.",
      "\"Stuck 3+ days\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M28-L03",
    "moduleId": "M28",
    "number": 3,
    "title": "Use the Truck Form",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Title \"<Stage> · <truck>\" — every Save writes the Dispatch Tracker field.",
      "Left panel facts are read-only; ask logistics if wrong.",
      "Block pills \"done\" / \"to do\" / \"optional\"; red \"*\" = required.",
      "\"Save (stay here)\" or \"Done → …\". \"Blocked: …\" lists what is missing."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Done\""
    }
  },
  {
    "id": "M28-L04",
    "moduleId": "M28",
    "number": 4,
    "title": "S5 Raise the sale bill",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Sale invoice\": upload, number, date.",
      "Or \"Generate Sale Invoice\" → \"Invoice number\" → \"Confirm & Generate\".",
      "\"E-way bill\": upload + number."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Confirm & Generate\""
    }
  },
  {
    "id": "M28-L05",
    "moduleId": "M28",
    "number": 5,
    "title": "S5 Pay the plant and the transporter advance",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Plant payment\" — mandatory unless vendor terms are credit.",
      "\"Vendor Bank Account\" is view-only — \"Ask logistics or admin to add the vendor…\".",
      "\"Transporter advance\" — \"Due ₹… · 90% suggested\".",
      "Transporter due panel."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M28-L06",
    "moduleId": "M28",
    "number": 6,
    "title": "S7 Record the plant's purchase bill",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Vendor's invoice\": upload + number.",
      "\"Totals off the paper\": taxable, tax.",
      "Check the expectation box: \"matches\" or not.",
      "\"Purchase e-way bill\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M28-L07",
    "moduleId": "M28",
    "number": 7,
    "title": "S11 Close the settlement",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Transporter final payment\".",
      "\"Halting charges applied?\" → slip.",
      "\"Shortage credit note to customer\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M28-L08",
    "moduleId": "M28",
    "number": 8,
    "title": "Post the plant's bill to the ledger (closed trucks too)",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Bills waiting to post\" in the Accounts Cockpit: Truck, Deal, Plant, Bill amount, Reached S5, Plant bill no.; a truck the buyer refused shows \"closed\".",
      "\"Post purchase bill\" on the row — the row leaves the list and \"DSP-… posted · PUR-…\" shows.",
      "Or press the truck number → its page, \"Plant's bill in the ledger\" → \"Post purchase bill\"; then it reads \"Posted · PUR-…\".",
      "A grey button with \"Cannot post: … it stays in Tally\" = the truck reached S5 before AURA started posting; its bill stays in Tally."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Post purchase bill\""
    }
  },
  {
    "id": "M29-L01",
    "moduleId": "M29",
    "number": 1,
    "title": "Ledger accounts and groups",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Ledger\" → \"Accounting\" — 12 tabs.",
      "\"Account Groups\": add a sub-group.",
      "\"Ledger Accounts\": \"Search ledgers...\", view, \"Add Ledger\", edit, delete."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M29-L02",
    "moduleId": "M29",
    "number": 2,
    "title": "Enter and post a voucher",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Voucher Entry\" → \"New Voucher\".",
      "Type, date, reference, lines.",
      "\"Save as Draft\" or \"Save & Post\". \"Debit and Credit must be equal\".",
      "Row \"Post\" / \"Cancel\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save & Post\""
    }
  },
  {
    "id": "M29-L03",
    "moduleId": "M29",
    "number": 3,
    "title": "Day Book, Trial Balance, P&L, Balance Sheet",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Day Book\" by date.",
      "\"Trial Balance\" — \"Balanced\" / \"NOT BALANCED\".",
      "\"Profit & Loss\" from / to.",
      "\"Balance Sheet\" as of."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M29-L04",
    "moduleId": "M29",
    "number": 4,
    "title": "Who owes what: Outstanding",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Outstanding\": \"Receivables (Debtors)\" / \"Payables (Creditors)\".",
      "Ageing columns 0-30 … 90+."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M29-L05",
    "moduleId": "M29",
    "number": 5,
    "title": "Reconcile a bank account",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Bank Reconciliation\" → pick the bank ledger.",
      "\"Book Balance\" tiles.",
      "Mark the bank date per voucher."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M29-L06",
    "moduleId": "M29",
    "number": 6,
    "title": "Cost centres and budgets",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Cost Centres\" → \"Add Cost Centre\"; \"View P&L\".",
      "\"Budgets\" → \"Create Budget\"; \"Variance Report\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M29-L07",
    "moduleId": "M29",
    "number": 7,
    "title": "Find any voucher in the Voucher Register",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Vouchers\" → \"Voucher Register\".",
      "Search, date preset, \"Filter by ledger account…\", status, types.",
      "\"CSV\", \"Print / PDF\".",
      "Open a voucher: lines, \"View original\", \"Print\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M29-L08",
    "moduleId": "M29",
    "number": 8,
    "title": "Trial Balance, P&L, Balance Sheet, Account Ledger reports",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "Footer links from the Voucher Register.",
      "\"As of\" / from-to; \"Print\".",
      "Account Ledger: date range → \"Apply\", \"CSV\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M30-L01",
    "moduleId": "M30",
    "number": 1,
    "title": "Find invoices",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Invoices\": tiles \"Total Invoiced\", \"Amount Due\", \"Paid\", \"Overdue\".",
      "Search, \"Filters\".",
      "Status in the row; \"Download PDF\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M30-L02",
    "moduleId": "M30",
    "number": 2,
    "title": "Create an invoice",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Create Invoice\".",
      "\"GST Mode:\", contact, account (or \"New\").",
      "Customer type, due date; the supply line says intra- or inter-state from the company profile.",
      "\"Line Items\", \"Invoice Discount\", \"Summary\".",
      "\"Create Invoice\"; \"Download PDF\"."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Create Invoice\""
    }
  },
  {
    "id": "M30-L03",
    "moduleId": "M30",
    "number": 3,
    "title": "Find purchase invoices",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Purchase Invoices\": tiles, search, status pills.",
      "Filters supplier and dates.",
      "\"Record First Vendor Bill\" if empty."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M30-L04",
    "moduleId": "M30",
    "number": 4,
    "title": "Record a vendor bill and post it",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"New Purchase Invoice\" — \"Bill Details\".",
      "TDS, BoE, reverse charge toggles.",
      "Items, ITC claim, totals, remarks.",
      "\"Save Draft\" → \"Save & Submit\" → \"Post to GL\".",
      "A posted bill shows \"View Voucher →\"."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Post to GL\""
    }
  },
  {
    "id": "M30-L05",
    "moduleId": "M30",
    "number": 5,
    "title": "Credit and debit notes",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Credit Notes\": filter by enquiry; status.",
      "\"Create Credit Note\": reason, contact, invoice reference.",
      "\"Debit Notes\" — same layout."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M30-L06",
    "moduleId": "M30",
    "number": 6,
    "title": "Review customer payment confirmations",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Payment Confirmations\": \"Pending\", \"Confirmed\", \"Rejected\".",
      "UTR / amount, screenshot \"View\".",
      "\"Confirm\" or \"Reject\" with a reason."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Confirm\""
    }
  },
  {
    "id": "M31-L01",
    "moduleId": "M31",
    "number": 1,
    "title": "Read GSTR-1, GSTR-3B and HSN from the books",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Accounting\" → \"GST Returns\": \"Month:\".",
      "\"GSTR-1\", \"GSTR-3B\", \"HSN Summary\".",
      "\"Export JSON\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M31-L02",
    "moduleId": "M31",
    "number": 2,
    "title": "Prepare GSTR-1",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"GST Filing\" — \"Period:\".",
      "\"Prepare GSTR-1\".",
      "Tiles and groups; \"No invoices found for this period\".",
      "Stop. \"Submit to GSTN\" is done by the filer, off camera."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Submit to GSTN\""
    }
  },
  {
    "id": "M31-L03",
    "moduleId": "M31",
    "number": 3,
    "title": "Prepare GSTR-3B",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Prepare GSTR-3B\".",
      "\"3.1 Outward Supplies\", \"4. Eligible ITC\", \"6. …\".",
      "Stop. \"File GSTR-3B\" needs the OTP — off camera."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"File GSTR-3B\""
    }
  },
  {
    "id": "M31-L06",
    "moduleId": "M31",
    "number": 6,
    "title": "Reconcile purchases with GSTR-2B",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"GSTR-2A/2B Reconciliation\".",
      "\"Return period\", \"GSTIN\", \"Upload 2B JSON\".",
      "\"Run matching\" → \"Matched\", \"Mismatch\", \"Missing in books\", \"Missing in 2B\".",
      "\"Match manually\" / \"Unmatch\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Run matching\""
    }
  },
  {
    "id": "M31-L07",
    "moduleId": "M31",
    "number": 7,
    "title": "GSTR-9 annual return",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"GSTR-9 Annual Return\" → \"Compute\".",
      "Override cells → \"Save overrides\".",
      "\"Finalize\" locks it. \"Export JSON\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Finalize\""
    }
  },
  {
    "id": "M31-L08",
    "moduleId": "M31",
    "number": 8,
    "title": "Export to Tally",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Tally Export\": \"Masters\" / \"Vouchers\" / \"Full\".",
      "\"From\" / \"To\"; \"Refresh preview\".",
      "\"Download XML\"; \"Export history\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M32-L01",
    "moduleId": "M32",
    "number": 1,
    "title": "Financial Reports",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Financial Reports\" — tabs, \"Print\".",
      "Trial Balance, Profit & Loss, Balance Sheet, Cash Flow.",
      "Receivables / Payables; General Ledger."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M32-L02",
    "moduleId": "M32",
    "number": 2,
    "title": "Set up payroll",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Payroll\" tabs.",
      "\"Components\" → \"+ New component\".",
      "\"Structures\" → \"+ New structure\".",
      "\"Assignments\" → \"+ Assign salary\".",
      "\"Periods\" → \"+ New period\"."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M32-L03",
    "moduleId": "M32",
    "number": 3,
    "title": "Run payroll and submit slips",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Runs\" → \"+ New run\".",
      "\"Run payroll\" → \"Pay N employees\" (cannot be undone).",
      "\"Slips\" → \"Submit\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Run payroll\""
    }
  },
  {
    "id": "M32-L04",
    "moduleId": "M32",
    "number": 4,
    "title": "Financial approvals",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Financial Approvals\" — status and type filters.",
      "\"Approve\" / \"Reject\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "deciding"
    }
  },
  {
    "id": "M32-L05",
    "moduleId": "M32",
    "number": 5,
    "title": "Security deposits",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Security Payments\" tiles; search.",
      "\"Record Payment\".",
      "\"Adjust\" / \"Return\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M32-L06",
    "moduleId": "M32",
    "number": 6,
    "title": "Invoice swap",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Invoice Swap — Trading Document Flow\" tiles.",
      "\"New Invoice Swap\".",
      "\"Tear\" marks the vendor invoice torn."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M32-L07",
    "moduleId": "M32",
    "number": 7,
    "title": "Expenses",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Expenses\" tiles; search; status.",
      "\"Add Expense\".",
      "Approve, view, delete."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M32-L08",
    "moduleId": "M32",
    "number": 8,
    "title": "Payments received",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Payments\" tiles and table.",
      "\"Record Payment\": invoice, amount, method.",
      "Delete a wrong payment."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M32-L09",
    "moduleId": "M32",
    "number": 9,
    "title": "Closing Register and Credit Ledger",
    "platform": "Web",
    "who": "Accountant",
    "audience": "accountant",
    "managerOnly": false,
    "adminOnly": false,
    "steps": [
      "\"Books\" → \"Closing Register\": every finished truck.",
      "\"Books\" → \"Credit Ledger\": open credit to plants and transporters."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M33-L01",
    "moduleId": "M33",
    "number": 1,
    "title": "The Admin Dashboard",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Dashboard\" opens \"Admin Dashboard\" — \"what needs your yes today\".",
      "Quick links \"Margin Desk\", \"Holding Desk\", \"Closing Register\", \"System Health\".",
      "\"Time range\".",
      "\"2 · Where every deal is\", \"4 · Team\", \"5 · Stuck the longest\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M33-L02",
    "moduleId": "M33",
    "number": 2,
    "title": "Read your numbers: Waiting on you",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"1 · Waiting on you\".",
      "\"Deals to approve\", \"Settlements to sign\", \"Rejections to decide\", \"Manual SO / PO\", \"Trucks blocked\".",
      "Each tile filters the lists below."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M33-L03",
    "moduleId": "M33",
    "number": 3,
    "title": "Approve a deal from the dashboard",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"3 · Approve\" — oldest first.",
      "\"Approve\" → \"Yes, approve\" (creates SO + PO).",
      "A loss needs \"Why is this loss acceptable?\".",
      "\"Reject →\" / \"Deal Desk →\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Yes, approve\""
    }
  },
  {
    "id": "M33-L04",
    "moduleId": "M33",
    "number": 4,
    "title": "Sign or send back a truck settlement",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Settlements to sign\".",
      "\"Sign\" → \"Yes, sign\".",
      "\"Send back…\" with your note.",
      "\"Closing Register →\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "signing"
    }
  },
  {
    "id": "M33-L05",
    "moduleId": "M33",
    "number": 5,
    "title": "Decide a rejection",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Rejections to decide\".",
      "\"Approve\" → \"Yes, approve\", or \"Reject…\" with remarks.",
      "\"Holding Desk →\" / \"Open →\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "deciding"
    }
  },
  {
    "id": "M33-L06",
    "moduleId": "M33",
    "number": 6,
    "title": "Manual SO / PO and blocked trucks",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "Fold \"Manual SO / PO · Trucks blocked\".",
      "Approve a manual order (a loss needs a reason).",
      "\"Trucks blocked\": why; \"Allocation Board →\" / \"Dispatch Tracker →\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "approving"
    }
  },
  {
    "id": "M34-L01",
    "moduleId": "M34",
    "number": 1,
    "title": "Find your way on the Margin Desk",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Veda Agro — Margin Desk\".",
      "Views \"Legacy\", \"Decision\", \"Historical\", \"Active Sales Orders\".",
      "\"Desk clear\" when nothing waits."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M34-L02",
    "moduleId": "M34",
    "number": 2,
    "title": "Approve a deal",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "Deal card: selling company, quantity, totals.",
      "\"Supplier lines · best margin first\".",
      "\"Approve · ₹… · ₹…/kg\".",
      "\"Approved\" — \"SO + PO created · in Active Sales Orders\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Approve\""
    }
  },
  {
    "id": "M34-L03",
    "moduleId": "M34",
    "number": 3,
    "title": "Approve some lots and return the rest",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "Per lot \"Approve\" / \"Return\".",
      "\"Approve N of M lots · return K\" + why."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "approving"
    }
  },
  {
    "id": "M34-L04",
    "moduleId": "M34",
    "number": 4,
    "title": "Send back or reject a deal",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Send back\" — pick the capability to fix, or \"Send back — general\".",
      "\"Send back\".",
      "\"Reject deal (no renegotiation)\" is permanent.",
      "\"Out for renegotiation\" lists what is waiting on the team."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "sending"
    }
  },
  {
    "id": "M34-L05",
    "moduleId": "M34",
    "number": 5,
    "title": "Approve or reject truck breakdown costs",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Truck breakdowns · extra costs\".",
      "Read each line and logistics' note.",
      "\"Approve ₹<total>\", or \"Note (needed to reject)\" → \"Reject\".",
      "\"Open truck\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "deciding"
    }
  },
  {
    "id": "M34-L06",
    "moduleId": "M34",
    "number": 6,
    "title": "Settlement batches and manual orders",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Pending Settlements\" → \"Approve\" / \"Reject\".",
      "\"Manual orders awaiting activation\": expand, read the margin.",
      "\"Approve\" / \"Approve anyway…\" (loss needs a reason)."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "approving"
    }
  },
  {
    "id": "M34-L07",
    "moduleId": "M34",
    "number": 7,
    "title": "Legacy, Historical and Active Sales Orders views",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Legacy\" cards and \"Send-back history\".",
      "\"Historical\" totals and filters.",
      "\"Active Sales Orders\" → \"Mark settled / paid\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Mark settled / paid\""
    }
  },
  {
    "id": "M35-L01",
    "moduleId": "M35",
    "number": 1,
    "title": "Lead Triage: see every lead without a salesperson",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "Admin Dashboard card \"<n> unassigned leads · oldest <x> days\" — or the red count on \"Leads\".",
      "\"Lead Triage\" — \"Every lead and open enquiry in one place. Send each one to a salesperson.\"",
      "Boxes \"Unassigned leads\", \"Open enquiries without a salesperson\", \"Created by reps (last 7 days)\", \"All leads\".",
      "Tabs \"Unassigned\", \"Open enquiries\", \"Created by reps\", \"All\".",
      "\"Search buyer, phone, commodity\", \"All states\", \"All commodities\", \"Any source\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M35-L02",
    "moduleId": "M35",
    "number": 2,
    "title": "Send leads to a salesperson",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "On a row pick the salesperson (the state default is the hint).",
      "Or tick rows: \"Send to\" → \"Pick salesperson…\" → \"Send\".",
      "\"Use state default\" sends each to its state's salesperson.",
      "\"Clear\" unticks."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Send\""
    }
  },
  {
    "id": "M35-L03",
    "moduleId": "M35",
    "number": 3,
    "title": "Territory defaults and workload",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Territory defaults\": set the salesperson for each state.",
      "\"Load by employee\": who holds how many leads.",
      "\"Back to triage\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M35-L04",
    "moduleId": "M35",
    "number": 4,
    "title": "Admin controls on Requirements and Customers",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "Requirements: \"Active\" / \"Archived\", \"Archive selected\", \"Delete permanently\", \"Restore a cancelled order\".",
      "Cancel an MD-approved order — only admin can.",
      "Customers: \"Deactivate\" / \"Reactivate\" / \"Delete\" (blocked if the customer has business)."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "each action"
    }
  },
  {
    "id": "M36-L01",
    "moduleId": "M36",
    "number": 1,
    "title": "Repair a deal in the Dispatch Tracker",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Override this gate\" → \"Clear the <gate> gate for this deal\".",
      "\"Move back\" → \"Move this deal back to <stage>\".",
      "\"Delete\" a file → \"Remove <file> from this deal\".",
      "\"Why? At least 10 characters — this is permanent.\" → \"Confirm\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Confirm\""
    }
  },
  {
    "id": "M36-L02",
    "moduleId": "M36",
    "number": 2,
    "title": "Resolve a delivery rejection from the sales order",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "On the SO: \"Delivery Rejected → Resolve\".",
      "Step 1: \"Rejected quantity (kg) *\", \"Reason *\".",
      "Step 2: the customer credit note and what happens to the goods.",
      "Step 3: cover from another enquiry."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "each step's save"
    }
  },
  {
    "id": "M36-L03",
    "moduleId": "M36",
    "number": 3,
    "title": "Rejection settlements and vendor debit notes",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Rejection Settlements\" → \"New settlement\".",
      "\"Attach truck\"; \"Vendor recovery\" (debit note); \"Reimbursements\" → \"Build reimbursements\".",
      "\"Submit for approval\" → \"Approve\" / \"Reject\".",
      "From Rejected Dispatches, \"Raise vendor debit note\" opens this desk."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "each save"
    }
  },
  {
    "id": "M36-L04",
    "moduleId": "M36",
    "number": 4,
    "title": "Holding Desk approvals and grounding",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Holding Desk\" → \"Approvals\": \"Nothing in this lane is payable until you approve it.\"",
      "Charge cards: transporter settlement, halting, detention.",
      "On a lot: \"Approve grounding\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "approving"
    }
  },
  {
    "id": "M36-L05",
    "moduleId": "M36",
    "number": 5,
    "title": "Closing Register and the Deal Dossier",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Closing Register\": \"Trucks closed\", \"Tonnage delivered\", \"Shortage\"; period; search.",
      "Open a truck: \"Quoted margin\", \"Two journeys\", statement, \"GST position\", \"Paper trail\".",
      "\"Download all N as ZIP\", \"Print dossier\".",
      "\"Reopen truck\" sends it back to the tracker."
    ],
    "minutes": {
      "web": 3
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Reopen truck\""
    }
  },
  {
    "id": "M36-L06",
    "moduleId": "M36",
    "number": 6,
    "title": "Delivery Pipeline with money",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Delivery Pipeline\": phases, \"Delivered\", \"Cards\" / \"Table\".",
      "\"What these trucks are priced to make…\".",
      "Card facts: sale, credit note, transporter, profit.",
      "\"Open this truck\" → Truck Dossier."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M36-L07",
    "moduleId": "M36",
    "number": 7,
    "title": "Credit Ledger",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Credit Ledger\" — every open credit obligation.",
      "\"All\" / \"Plant\" / \"Transporter\"; \"Open only\"."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M36-L08",
    "moduleId": "M36",
    "number": 8,
    "title": "See any desk as its owner sees it",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "Commodity Deals now has \"Trading Dashboard\", \"Dispatch Tracker\", \"Holding Desk\", \"Rejected Dispatches\".",
      "\"View as…\" → \"Browse sidebar as\" a role to check what each person sees.",
      "The Trading Dashboard shows every rep's work for you."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M37-L01",
    "moduleId": "M37",
    "number": 1,
    "title": "Add and edit users",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Settings\" → \"Users & Roles\".",
      "Search, department, type.",
      "\"Add User\": name, email, role, department.",
      "Edit a row; \"Active\" / \"Inactive\" toggle."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M37-L02",
    "moduleId": "M37",
    "number": 2,
    "title": "Send someone a password reset",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Users & Roles\" → the key button on an active user (\"Send password reset email\").",
      "\"Reset email sent to <email>\".",
      "The person sets a new password from the email (same as \"Forgot password?\")."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": false,
      "reason": "sends an email"
    }
  },
  {
    "id": "M37-L03",
    "moduleId": "M37",
    "number": 3,
    "title": "Sessions and devices",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Who is signed in\" — phones, browsers, slots.",
      "\"Sign out the phone\" / \"Sign out the browser\" / \"Sign out both\".",
      "Device history."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "signing out"
    }
  },
  {
    "id": "M37-L04",
    "moduleId": "M37",
    "number": 4,
    "title": "Login history and audit logs",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Login & Device History\": who, device, IP, time.",
      "\"Audit Logs\": activity in your own workspace."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M37-L05",
    "moduleId": "M37",
    "number": 5,
    "title": "People",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"People\" — \"Employees\" / \"Teams\".",
      "\"Add Employee\".",
      "Edit; delete is blocked when the person has activity."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M37-L06",
    "moduleId": "M37",
    "number": 6,
    "title": "Departments and general settings",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Settings\" → \"Departments\" (only admin and owner see this tab): set the head.",
      "\"General Settings\": currency, date format, financial year."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  },
  {
    "id": "M37-L07",
    "moduleId": "M37",
    "number": 7,
    "title": "Company Profile — what every document prints",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Company Profile\": \"Identity\" (legal name, GSTIN decides IGST vs CGST+SGST).",
      "\"Registered address\", \"Bank details\", \"Invoice defaults\".",
      "\"How it will print\" preview.",
      "\"Save changes\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "\"Save changes\""
    }
  },
  {
    "id": "M37-L08",
    "moduleId": "M37",
    "number": 8,
    "title": "Approve or reject leave",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Leaves\" → \"My Team\".",
      "\"Approve\" / \"Reject\" with a note."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "deciding"
    }
  },
  {
    "id": "M37-L09",
    "moduleId": "M37",
    "number": 9,
    "title": "System Health and the sales Pipeline",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"System Health\": users, \"App health\", \"User adoption\".",
      "\"Pipeline\": staff scope, KPIs, \"Enquiry funnel\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true
    }
  },
  {
    "id": "M37-L10",
    "moduleId": "M37",
    "number": 10,
    "title": "Work bug reports in the Resolution Centre",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "\"Resolution Centre\": \"TOTAL TICKETS\", \"OPEN\", \"IN PROGRESS\", \"RESOLVED\".",
      "Tabs \"Active\", \"My reported\", \"All\".",
      "Assign a ticket; change its status.",
      "\"Report an ERP issue\"."
    ],
    "minutes": {
      "web": 2
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "changing status"
    }
  },
  {
    "id": "M37-L11",
    "moduleId": "M37",
    "number": 11,
    "title": "Change a vendor bank account on file",
    "platform": "Web",
    "who": "Admin only — MD",
    "audience": "admin",
    "managerOnly": false,
    "adminOnly": true,
    "steps": [
      "Truck Form S5 \"Vendor Bank Account\" — edit mode is admin only.",
      "\"Account number\", \"IFSC\", \"Name (as on bank)\".",
      "Save."
    ],
    "minutes": {
      "web": 1
    },
    "showMe": {
      "allowed": true,
      "stopBefore": "saving"
    }
  }
];

/** Section 5 — a new joiner of each department does these first, in this order. */
export const TOUR_FIRST_DAY: Record<TourPathKey, string[]> = {
  "sales": [
    "M01-L01",
    "M01-L04",
    "M01-L05",
    "M03-L02",
    "M03-L01",
    "M04-L01",
    "M04-L02",
    "M05-L01",
    "M02-L02",
    "M08-L07",
    "M07-L01",
    "M01-L08",
    "M08-L02"
  ],
  "purchase": [
    "M12-L01",
    "M12-L04",
    "M15-L02",
    "M15-L03",
    "M15-L05",
    "M15-L06",
    "M15-L09",
    "M12-L02",
    "M11-L06"
  ],
  "logistics": [
    "M20-L01",
    "M20-L04",
    "M25-L01",
    "M25-L02",
    "M21-L01",
    "M23-L02",
    "M20-L02",
    "M11-L06"
  ],
  "accountant": [
    "M28-L01",
    "M28-L03",
    "M28-L04",
    "M28-L06",
    "M28-L07",
    "M28-L02",
    "M29-L07",
    "M11-L06"
  ],
  "admin": [
    "M33-L01",
    "M33-L02",
    "M34-L02",
    "M34-L04",
    "M35-L01",
    "M35-L02",
    "M37-L01",
    "M37-L02",
    "M37-L10"
  ]
};
/** Section 5 — "Second day: …" lines. */
export const TOUR_SECOND_DAY: Partial<Record<TourPathKey, string[]>> = {
  "sales": [
    "M02-L07",
    "M03-L03",
    "M04-L03",
    "M06-L01",
    "M06-L02",
    "M10-L01",
    "M10-L03",
    "M01-L06"
  ]
};
/** Section 5 — "Everyone on the web also does …" in the first week. */
export const TOUR_EVERYONE_WEB_FIRST_WEEK: string[] = ["M01-L07","M11-L01"];
/** Section 6 — a manager does the first-day path, then these. */
export const TOUR_MANAGER_PATHS: Record<TourManagerPathKey, string[]> = {
  "salesManager": [
    "M08-L08",
    "M03-L11",
    "M10-L01",
    "M10-L03",
    "M08-L05",
    "M09-L06",
    "M10-L06"
  ],
  "purchaseHead": [
    "M15-L08",
    "M16-L01",
    "M16-L04",
    "M18-L01",
    "M18-L02",
    "M17-L03",
    "M19-L02"
  ]
};
